/*
 * Storybook Customizer -- 5-step flow controller.
 *
 *   1 Who is in the book   name + role per person, hero first
 *   2 Age and gender       gender for everyone, age for the hero only
 *   3 The story theme      subjects led by gender, situations led by the hero's age
 *   4 How it looks         palette led by theme + age + gender
 *   5 The photo            one face per person, checked before anything is drawn
 *   6 Painting             both pictures at once; the phone code is asked for here,
 *                          and the first pages of the story can be read while waiting
 *   7 Preview              the whole story to flip through, two pictures painted
 *
 * THE CATALOGUE BELOW IS TEMPORARY. Bands, subjects and palettes belong in
 * apps/macmerise-storybook and should arrive from /api/themes once that endpoint
 * serves them. It is generated from the design data, so edit it there and
 * regenerate rather than hand-editing here.
 */
(function () {
  'use strict';

  var BANDS = [
    {
      "key": "2-3",
      "label": "2-3",
      "note": "Three to six words a line. Humour is physical, not verbal. Nothing frightening, and nothing left uncertain.",
      "situations": [
        {
          "key": "my-whole-day",
          "name": "My Whole Day",
          "line": "Wakes up, eats, plays, goes to bed — the hero of their own house.",
          "register": "cosy"
        },
        {
          "key": "puddles-after-rain",
          "name": "Puddles After Rain",
          "line": "Jumps in every puddle on the way home and gets soaked.",
          "register": "silly"
        },
        {
          "key": "bubbles-at-bath-time",
          "name": "Bubbles at Bath Time",
          "line": "Sails a toy boat through the bubbles and laughs at every splash.",
          "register": "cosy"
        },
        {
          "key": "a-nap-with-teddy",
          "name": "A Nap with Teddy",
          "line": "They and their favourite toy get sleepy and fall asleep side by side.",
          "register": "cosy"
        },
        {
          "key": "the-tower-that-fell",
          "name": "The Tower That Fell",
          "line": "Stacks blocks higher and higher until it wobbles and tips over.",
          "register": "silly"
        },
        {
          "key": "at-the-park",
          "name": "At the Park",
          "line": "Swings, slides, meets a dog, walks home happy and tired.",
          "register": "silly"
        },
        {
          "key": "kitchen-dance-party",
          "name": "Kitchen Dance Party",
          "line": "Dances round the kitchen with everyone, a spoon for a microphone.",
          "register": "silly"
        },
        {
          "key": "hello-to-every-animal",
          "name": "Hello to Every Animal",
          "line": "Visits a farm and copies each animal's sound and walk in turn.",
          "register": "funny"
        }
      ]
    },
    {
      "key": "4-5",
      "label": "4-5",
      "note": "Short sentences, one small problem that gets solved. A scary moment is fine if it ends fast and safe.",
      "situations": [
        {
          "key": "the-lost-toy",
          "name": "The Lost Toy",
          "line": "Their favourite toy goes missing. A search of the house ends in a happy find.",
          "register": "curious"
        },
        {
          "key": "the-wobbly-tooth",
          "name": "The Wobbly Tooth",
          "line": "A first loose tooth wiggles all day and finally pops out at dinner.",
          "register": "proud"
        },
        {
          "key": "the-first-cycle-ride",
          "name": "The First Cycle Ride",
          "line": "Wobbles and falls a few times, then rides straight down the street.",
          "register": "proud"
        },
        {
          "key": "one-cookie-too-many",
          "name": "One Cookie Too Many",
          "line": "Sneaks extra biscuits, gets a funny tummy ache, decides one is enough.",
          "register": "funny"
        },
        {
          "key": "the-noise-at-night",
          "name": "The Noise at Night",
          "line": "Hears something in the dark, works up the courage to look, finds the cat.",
          "register": "brave"
        },
        {
          "key": "the-puddle-too-big",
          "name": "The Puddle Too Big",
          "line": "Leaps a huge puddle, lands in the middle, calls it the best part of the day.",
          "register": "silly"
        },
        {
          "key": "the-last-slice",
          "name": "The Last Slice",
          "line": "Wants the last piece of cake, then decides to split it.",
          "register": "proud"
        },
        {
          "key": "the-costume-problem",
          "name": "The Costume Problem",
          "line": "A homemade costume falls apart again and again, and they fix it their own way each time.",
          "register": "silly"
        }
      ]
    },
    {
      "key": "6-7",
      "label": "6-7",
      "note": "Longer sentences and a problem with real steps. A setback works when their own choice fixes it.",
      "situations": [
        {
          "key": "the-sandcastle-rebuild",
          "name": "The Sandcastle Rebuild",
          "line": "A wave flattens the sandcastle. They rebuild it better before sunset.",
          "register": "proud"
        },
        {
          "key": "the-lost-library-book",
          "name": "The Lost Library Book",
          "line": "Loses a borrowed book, retraces the whole day, returns it just in time.",
          "register": "curious"
        },
        {
          "key": "race-to-the-gate",
          "name": "Race to the Gate",
          "line": "Races a parent to the gate every single day, and finally wins.",
          "register": "funny"
        },
        {
          "key": "a-blackout-at-home",
          "name": "A Blackout at Home",
          "line": "The power goes out. The family tells stories by candlelight instead.",
          "register": "cosy"
        },
        {
          "key": "dinner-gone-wrong",
          "name": "Dinner Gone Wrong",
          "line": "Helps cook, everything goes wrong, and the odd meal turns out delicious.",
          "register": "funny"
        },
        {
          "key": "a-friend-left-out",
          "name": "A Friend Left Out",
          "line": "Notices a classmate left out of a game, and invites them in.",
          "register": "brave"
        },
        {
          "key": "picked-last-scores-first",
          "name": "Picked Last, Scores First",
          "line": "Picked last for the team, feels it, then makes the winning play.",
          "register": "proud"
        },
        {
          "key": "the-class-election",
          "name": "The Class Election",
          "line": "Runs for class monitor, loses a friend's support, wins it back by playing fair.",
          "register": "brave"
        }
      ]
    },
    {
      "key": "8-9",
      "label": "8-9",
      "note": "Full sentences and a twist held across the book. Real tension works when the ending affirms who they are.",
      "situations": [
        {
          "key": "the-note-nobody-signed",
          "name": "The Note Nobody Signed",
          "line": "A kind note arrives unsigned. They spend the book working out who sent it.",
          "register": "curious"
        },
        {
          "key": "last-in-the-race",
          "name": "Last in the Race",
          "line": "Comes last in the school race, having stopped to help a runner who fell.",
          "register": "proud"
        },
        {
          "key": "blamed-for-no-reason",
          "name": "Blamed for No Reason",
          "line": "Blamed for a sibling's mistake, and has to decide whether to speak up.",
          "register": "brave"
        },
        {
          "key": "the-rematch",
          "name": "The Rematch",
          "line": "Loses to the same rival every year, then works out what to change.",
          "register": "proud"
        },
        {
          "key": "the-first-night-away",
          "name": "The First Night Away",
          "line": "Packs nervously for a first school trip, comes back with a new best friend.",
          "register": "brave"
        },
        {
          "key": "the-talent-show-mix-up",
          "name": "The Talent Show Mix-Up",
          "line": "Forgets the act on stage, and improvises something better.",
          "register": "brave"
        },
        {
          "key": "the-tiffin-trade",
          "name": "The Tiffin Trade",
          "line": "Runs a lunchbox-swapping business until one trade goes wrong.",
          "register": "funny"
        },
        {
          "key": "the-wedding-dance-floor",
          "name": "The Wedding Dance Floor",
          "line": "Too embarrassed to dance at a family wedding, practises alone, then owns the floor.",
          "register": "funny"
        }
      ]
    }
  ];

  var SUBJECTS = [
    {
      "key": "cars-and-racing",
      "name": "Cars and racing",
      "lean": "he",
      "line": "Fast, loud, and first past the flag.",
      "icon": "<path d=\"M8 40h48\"></path><path d=\"M14 40v-8a6 6 0 0 1 6-6h8l7 6h11a6 6 0 0 1 6 6v8\"></path><circle cx=\"21\" cy=\"44\" r=\"5\"></circle><circle cx=\"45\" cy=\"44\" r=\"5\"></circle>"
    },
    {
      "key": "dinosaurs",
      "name": "Dinosaurs",
      "lean": "he",
      "line": "Big feet, big teeth, a very long tail.",
      "icon": "<path d=\"M12 46c0-12 8-20 18-20 8 0 12 4 16 4 4 0 6-3 6-3\"></path><path d=\"M12 46l-4 6M30 46v6M40 44v8\"></path><path d=\"M18 34c-6 2-10 6-12 12\"></path><circle cx=\"46\" cy=\"28\" r=\"1.6\"></circle>"
    },
    {
      "key": "diggers-and-trucks",
      "name": "Diggers and trucks",
      "lean": "he",
      "line": "A bucket, a heap of mud, and a job to finish.",
      "icon": "<path d=\"M8 46h34v-12H8z\"></path><circle cx=\"17\" cy=\"50\" r=\"4\"></circle><circle cx=\"34\" cy=\"50\" r=\"4\"></circle><path d=\"M42 40l8-18 6 4-6 16\"></path><path d=\"M48 42h12v8H48z\"></path>"
    },
    {
      "key": "trains",
      "name": "Trains",
      "lean": "he",
      "line": "Down the track, through the tunnel, all the way there.",
      "icon": "<path d=\"M14 16h30v24H14z\"></path><path d=\"M14 40h36l6 8H8z\"></path><circle cx=\"20\" cy=\"52\" r=\"3\"></circle><circle cx=\"44\" cy=\"52\" r=\"3\"></circle><path d=\"M20 22h18v10H20z\"></path>"
    },
    {
      "key": "space-and-rockets",
      "name": "Space and rockets",
      "lean": "both",
      "line": "Up through the roof and past the moon.",
      "icon": "<path d=\"M32 8c7 6 10 15 10 24l-10 8-10-8c0-9 3-18 10-24z\"></path><circle cx=\"32\" cy=\"24\" r=\"4\"></circle><path d=\"M22 36l-6 12 10-5M42 36l6 12-10-5\"></path>"
    },
    {
      "key": "dragons",
      "name": "Dragons",
      "lean": "both",
      "line": "Wings, smoke, and a friend nobody expected.",
      "icon": "<path d=\"M12 42c6-14 18-20 28-18\"></path><path d=\"M40 24c6-6 12-6 14 0 2 6-2 10-8 10\"></path><path d=\"M24 34c-6-8-14-10-16-4 8 0 8 8 16 10\"></path><path d=\"M12 42l-4 8 12-2\"></path><circle cx=\"46\" cy=\"27\" r=\"1.6\"></circle>"
    },
    {
      "key": "pirates",
      "name": "Pirates",
      "lean": "both",
      "line": "A map, a ship, and a hole in the sand.",
      "icon": "<path d=\"M32 8v34\"></path><path d=\"M32 12l16 6-16 6z\"></path><path d=\"M10 42h44l-8 12H18z\"></path><path d=\"M20 30h10\"></path>"
    },
    {
      "key": "big-cats",
      "name": "Big cats",
      "lean": "both",
      "line": "Quiet paws in the long grass.",
      "icon": "<path d=\"M18 24l-4-10 10 5\"></path><path d=\"M46 24l4-10-10 5\"></path><path d=\"M32 16c9 0 16 8 16 18s-7 18-16 18-16-8-16-18 7-18 16-18z\"></path><circle cx=\"26\" cy=\"32\" r=\"1.8\"></circle><circle cx=\"38\" cy=\"32\" r=\"1.8\"></circle><path d=\"M28 40c2 2 6 2 8 0\"></path>"
    },
    {
      "key": "unicorns",
      "name": "Unicorns",
      "lean": "she",
      "line": "One horn, and a mane you can plait.",
      "icon": "<path d=\"M22 50V34c0-8 6-14 14-14h6\"></path><path d=\"M42 20l8-12-2 12 6-2-8 8\"></path><path d=\"M36 20c-4-4-4-8 0-10\"></path><path d=\"M22 50h6M40 34v16\"></path><circle cx=\"44\" cy=\"26\" r=\"1.6\"></circle>"
    },
    {
      "key": "princesses",
      "name": "Princesses",
      "lean": "she",
      "line": "A crown, a plan, and a castle to run.",
      "icon": "<path d=\"M12 44h40l4-24-12 8-12-14-12 14-12-8z\"></path><path d=\"M12 50h40\"></path><circle cx=\"32\" cy=\"30\" r=\"2\"></circle>"
    },
    {
      "key": "fairies",
      "name": "Fairies",
      "lean": "she",
      "line": "Small wings, and a wood that stays awake at night.",
      "icon": "<path d=\"M32 20a6 6 0 1 1 0 12 6 6 0 0 1 0-12z\"></path><path d=\"M32 32v14\"></path><path d=\"M28 26c-10-10-20-6-16 2s12 6 16 2M36 26c10-10 20-6 16 2s-12 6-16 2\"></path><path d=\"M50 12l1.5 3 3 1.5-3 1.5L50 21l-1.5-3-3-1.5 3-1.5z\"></path>"
    },
    {
      "key": "mermaids",
      "name": "Mermaids",
      "lean": "she",
      "line": "Down where the light goes green.",
      "icon": "<circle cx=\"32\" cy=\"18\" r=\"7\"></circle><path d=\"M32 25c-6 4-8 12-4 18l4 6 4-6c4-6 2-14-4-18z\"></path><path d=\"M32 49c-6 4-10 4-14 2 4-2 6-6 6-10M32 49c6 4 10 4 14 2-4-2-6-6-6-10\"></path>"
    },
    {
      "key": "ballet-and-dancing",
      "name": "Ballet and dancing",
      "lean": "she",
      "line": "On her toes, in front of everyone.",
      "icon": "<circle cx=\"32\" cy=\"14\" r=\"5\"></circle><path d=\"M32 19v14\"></path><path d=\"M20 26l12 7 12-7\"></path><path d=\"M32 33l-6 10 4 10M32 33l6 10-2 10\"></path>"
    },
    {
      "key": "horses",
      "name": "Horses",
      "lean": "both",
      "line": "A gallop, and a field with no fence.",
      "icon": "<path d=\"M14 50V36c0-8 8-12 16-12h8l6-8 4 4-2 8\"></path><path d=\"M46 28c4 2 6 6 6 12v10\"></path><path d=\"M22 50v-8M38 50v-8\"></path><path d=\"M38 24c-4-4-8-4-10 0\"></path>"
    },
    {
      "key": "cakes-and-baking",
      "name": "Cakes and baking",
      "lean": "both",
      "line": "Flour everywhere, and something worth it at the end.",
      "icon": "<path d=\"M12 34h40v16H12z\"></path><path d=\"M16 34c0-6 6-8 16-8s16 2 16 8\"></path><path d=\"M32 26v-6M32 20c-3-3 0-6 0-6s3 3 0 6z\"></path><path d=\"M12 42h40\"></path>"
    },
    {
      "key": "the-deep-sea",
      "name": "The deep sea",
      "lean": "both",
      "line": "Past the light, to see what lives down there.",
      "icon": "<path d=\"M8 18c5-4 10-4 15 0s10 4 15 0 10-4 14 0\"></path><circle cx=\"26\" cy=\"36\" r=\"10\"></circle><path d=\"M36 36l12-7v14z\"></path><circle cx=\"22\" cy=\"33\" r=\"1.8\"></circle><path d=\"M50 44c3 2 6 2 8 0\"></path>"
    }
  ];

  var PALETTES = [
    {
      "key": "midnight",
      "name": "Midnight",
      "lean": "he",
      "ages": "3-7",
      "why": "Cream pages, gold lettering, night skies in the pictures.",
      "cover": "#12274A",
      "coverInk": "#E8B23C",
      "panel": "#FBF4E4",
      "ink": "#33302B",
      "accent": "#E8B23C",
      "swatches": [
        "#12274A",
        "#E8B23C",
        "#C4402A",
        "#FBF4E4",
        "#1C3E63"
      ],
      "display": "Baloo 2",
      "dfam": "'Baloo 2', 'DM Sans', Arial, sans-serif",
      "dls": "0",
      "body": "Andika",
      "bfam": "'Andika', Georgia, serif",
      "art": "Coloured pencil and watercolour"
    },
    {
      "key": "blossom",
      "name": "Blossom",
      "lean": "she",
      "ages": "3-7",
      "why": "Warm rose and gold, with soft, gentle pictures.",
      "cover": "#F5B8CB",
      "coverInk": "#8E2B52",
      "panel": "#FFF3F5",
      "ink": "#2A1A20",
      "accent": "#C2557A",
      "swatches": [
        "#C2557A",
        "#F5B8CB",
        "#E8B84B",
        "#FFF3F5",
        "#2A1A20"
      ],
      "display": "Quicksand",
      "dfam": "'Quicksand', 'DM Sans', Arial, sans-serif",
      "dls": "-0.01em",
      "body": "Andika",
      "bfam": "'Andika', Georgia, serif",
      "art": "Coloured pencil and watercolour"
    },
    {
      "key": "sunrise",
      "name": "Sunrise",
      "lean": "both",
      "ages": "2-5",
      "why": "Louder and warmer. Good for a rescue or a first day.",
      "cover": "#FFC94A",
      "coverInk": "#B8391F",
      "panel": "#FFF6E8",
      "ink": "#2B2118",
      "accent": "#F2765C",
      "swatches": [
        "#F2765C",
        "#FFC94A",
        "#A8D8E8",
        "#FFF6E8",
        "#2B2118"
      ],
      "display": "Fredoka",
      "dfam": "'Fredoka', 'DM Sans', Arial, sans-serif",
      "dls": "0",
      "body": "Andika",
      "bfam": "'Andika', Georgia, serif",
      "art": "Soft gouache"
    },
    {
      "key": "inkwash",
      "name": "Ink and wash",
      "lean": "both",
      "ages": "6-9",
      "why": "Quieter and older. Good for a jungle or the sea.",
      "cover": "#8FA37E",
      "coverInk": "#1E1E1C",
      "panel": "#F2EDE1",
      "ink": "#1E1E1C",
      "accent": "#8FA37E",
      "swatches": [
        "#8FA37E",
        "#C9974A",
        "#46545B",
        "#F2EDE1",
        "#1E1E1C"
      ],
      "display": "Literata",
      "dfam": "'Literata', Georgia, serif",
      "dls": "-0.01em",
      "body": "Andika",
      "bfam": "'Andika', Georgia, serif",
      "art": "Ink line and wash"
    },
    {
      "key": "nightracer",
      "name": "Night Racer",
      "lean": "both",
      "ages": "8-9",
      "why": "Black and red, nothing soft. For a child who is done with pastel.",
      "cover": "#101010",
      "coverInk": "#D8342B",
      "panel": "#101010",
      "ink": "#EDE9E2",
      "accent": "#D8342B",
      "swatches": [
        "#101010",
        "#D8342B",
        "#6E7A82",
        "#EDE9E2",
        "#8A8177"
      ],
      "display": "Bricolage Grotesque",
      "dfam": "'Bricolage Grotesque', Arial, sans-serif",
      "dls": "-0.03em",
      "body": "Literata",
      "bfam": "'Literata', Georgia, serif",
      "art": "Ink line and flat colour"
    }
  ];

  var ROLES = [
    { key: 'hero',        name: 'The hero' },
    { key: 'brother',     name: 'Brother' },
    { key: 'sister',      name: 'Sister' },
    { key: 'twin_brother', name: 'Twin brother' },
    { key: 'twin_sister', name: 'Twin sister' },
    { key: 'friend',      name: 'Friend' },
    { key: 'mum',         name: 'Mum' },
    { key: 'dad',         name: 'Dad' },
    { key: 'grandmother', name: 'Grandma' },
    { key: 'grandfather', name: 'Grandpa' },
    { key: 'cousin',      name: 'Cousin' }
  ];

  /* A mum is a she and a dad is a he. Only a friend or a cousin is asked. */
  var IMPLIED = { mum: 'she', sister: 'she', grandmother: 'she', dad: 'he', brother: 'he', grandfather: 'he',
                  twin_brother: 'he', twin_sister: 'she' };

  /* The cover choice counts when the parent picked one, or when the book had
     someone besides the child before the chat: a person added in the chat to a
     book that never showed the choice does not move onto the cover. */
  function coverApplies() {
    return state.cast.length > 1 && (!!state.coverChosen || state.cast.some(function (p, i) { return i > 0 && !p.viaChat; }));
  }

  /* A person as the draft keeps them: no blob: photo link (it dies on reload),
     the small thumbnail instead. */
  function personRecord(p) {
    return { id: p.id, name: p.name, role: p.role, gender: p.gender, age: p.age,
             thumb: p.thumb || null, photoPath: p.photoPath, referenceId: p.referenceId, viaChat: !!p.viaChat };
  }

  function personFromRecord(p) {
    return { id: p.id, name: p.name || '', role: p.role, gender: p.gender || '', age: p.age,
             photo: p.thumb, thumb: p.thumb, photoPath: p.photoPath || null, referenceId: p.referenceId || null, viaChat: !!p.viaChat };
  }

  /* At most two: each photo slows every picture it is drawn into. */
  var MAX_THINGS = 2;

  function thingRecord(t) {
    return { id: t.id, name: t.name, thumb: t.thumb || null, photoPath: t.photoPath || null };
  }

  function thingFromRecord(t) {
    return { id: t.id, kind: 'thing', name: t.name || '', photo: t.thumb || null, thumb: t.thumb || null, photoPath: t.photoPath || null };
  }

  /* The words the story uses for it: "my jeep" and "the jeep" are one jeep,
     which the server would refuse. Same rule as thingLabel in the API. */
  var THING_LEADING = /^(?:(?:my|his|her|their|our|the|a|an|[\p{L}]+'s|[\p{L}]+’s)\s+)+/iu;
  function thingKey(name) { return name.trim().replace(/\s+/g, ' ').replace(THING_LEADING, '').trim().toLowerCase(); }

  /* Why a thing cannot be used yet, or '' when it can. */
  function thingProblem(t) {
    var key = thingKey(t.name);
    if (!key) return 'Name it so the story can use it.';
    var first = state.things.filter(function (x) { return thingKey(x.name) === key; })[0];
    return first === t ? '' : 'Give it a name of its own.';
  }

  function thingNames() {
    return state.things.map(function (t) { return { name: t.name.trim() }; }).filter(function (t) { return t.name; });
  }

  function findPersonById(id) {
    for (var i = 0; i < state.cast.length; i++) if (state.cast[i].id === id) return state.cast[i];
    return null;
  }

  function cloneCast() {
    return state.cast.map(personRecord);
  }

  /* A brother or sister may be asked their age (Sahil, 5 Oct 2026); a twin is
     the hero's age. Everyone else has none: the writer only needs the role. */
  function personAge(p) {
    if (p === hero()) return p.age;
    if (p.role === 'twin_brother' || p.role === 'twin_sister') return hero().age;
    if ((p.role === 'brother' || p.role === 'sister') && typeof p.age === 'number') return p.age;
    return undefined;
  }
  /* What the child calls them goes in the story, so suggest that. */
  var CALLED = { mum: 'e.g. Mama', dad: 'e.g. Papa', grandmother: 'e.g. Nani', grandfather: 'e.g. Dada' };

  /* ---------- state ---------- */

  var root = document.getElementById('storybook-customizer');
  if (!root) return;

  var API = (root.dataset.apiBase || '').replace(/\/$/, '');
  var AUTH = (root.dataset.authBase || 'https://checkout-api.macmerise.com').replace(/\/$/, '');
  var MAX_PEOPLE = parseInt(root.dataset.maxCharacters, 10) || 4;
  var VARIANTS = {
    softcover: (root.dataset.softcoverVariant || '').trim(),
    hardcover: (root.dataset.hardcoverVariant || '').trim()
  };
  var nextId = 1;

  var state = {
    step: 1,
    cast: [{ id: nextId++, name: '', role: 'hero', gender: '', age: 5, photo: null, photoPath: null, referenceId: null }],
    /* The child's favourite things (Sahil, 6 Oct 2026): a name, then a photo at
       step 5. Not people: no role, no age, never on the cover pick. */
    things: [],
    band: null,
    theme: null,
    ownIdea: '',
    // Who is on the front cover once anyone else is in the book. Everyone by
    // default: a parent who adds Papa and Dadi wants them on the front.
    cover: 'everyone',
    // People (by id) whose names join the child's in the title: "Ira & Tara and the ...".
    coHeroIds: [],
    look: null,
    generationId: null,
    bookTitle: '',
    pages: [],
    pageIndex: 0,
    /* The story request is fired the moment the theme is chosen, at the end of
       step 3, and held here as a promise. The parent then spends 30 to 60
       seconds on the look and the photos while it runs, so the ~16s write
       finishes off the critical path. */
    storyPromise: null,
    storyKey: null,
    story: null,
    /* Ids of the running story and preview jobs, kept so a reloaded tab can
       ask for the same result instead of paying for it again. */
    storyJobId: null,
    previewJobId: null,
    /* A preview that finished before the phone code was in. */
    heldPreview: null,
    /* Five short lines about this child and this theme, for the look cards. */
    teasers: null,
    teaserKey: null,
    /* The page of the story being read while the pictures are created. */
    readerIndex: 0,
    /* A finished preview the parent opens from the row, when they choose. */
    readyPreview: null,
    /* The story-change chat: the book's private edit key, changes used, and a
       change waiting for the book record to exist. */
    editKey: null,
    editsUsed: 0,
    pendingSave: null,
    /* What the book record holds now, the story and the people: what a change
       that cannot be saved goes back to. Kept in the draft. */
    saved: null,
    /* A change could not be saved and there is no snapshot to go back to:
       the page no longer matches the book, so the cart refuses it. */
    outOfSync: false,
    saving: false,
    chatBusy: false,
    /* The drawing-screen clock. Held so a retry can stop the previous one. */
    ticker: null,
    /* Sign-in. Both the photo check and the preview spend real money per call,
       so both API routes need a session. A parent who signed in at the checkout
       popup already has one -- checkSession finds it and the gate never shows. */
    session: null,
    sessionChecked: false,
    /* True when the api answered 5xx -- our fault, not a sign-in problem. */
    sessionBroken: false,
    otpSessionId: null,
    otpPhone: ''
  };

  /* ---------- small helpers ---------- */

  function $(sel, scope) { return (scope || root).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function hero() { return state.cast[0]; }
  function heroName() { return (hero().name || '').trim(); }
  function possessive(name) { return name + '’s'; }
  function bandFor(age) {
    for (var i = 0; i < BANDS.length; i++) {
      var r = BANDS[i].key.split('-');
      if (age >= +r[0] && age <= +r[1]) return BANDS[i];
    }
    return BANDS[age < 2 ? 0 : BANDS.length - 1];
  }
  /* credentials: 'include' is what carries mc_session. The cookie is set on
     .macmerise.com by checkout-api, so the browser will send it to
     storybook.macmerise.com -- but ONLY if the request asks for credentials.
     Without this line every authed call is a 401, however signed in the
     parent is. */
  function withCredentials(opts) {
    var o = {};
    for (var k in (opts || {})) { if (Object.prototype.hasOwnProperty.call(opts, k)) o[k] = opts[k]; }
    o.credentials = 'include';
    return o;
  }

  function apiFetch(path, opts) {
    return fetch(API + path, withCredentials(opts)).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (body) {
          var err = new Error('Request failed: ' + r.status);
          err.status = r.status;
          try { err.body = JSON.parse(body); } catch (e) { err.body = { error: body }; }
          throw err;
        });
      }
      return r.json();
    });
  }

  /* Writing the story and drawing the preview each take up to two minutes.
     A phone drops a request it has waited on that long -- the screen locks,
     the parent checks WhatsApp, the network blinks -- and on 21 Sep a parent
     on Safari lost four finished books that way. So both run as jobs: the
     first call answers at once with a job id, and pollJob asks for the result
     every few seconds. A check that fails is simply asked again, and the page
     asks straight away when the phone wakes up. A backend that does not know
     about jobs answers with the result itself, and that is passed through. */
  var JOB_POLL_MS = 3000;
  var JOB_CHECK_TIMEOUT_MS = 15000;     // one check that hangs is abandoned, not waited on
  var JOB_MAX_WAIT_MS = 11 * 60 * 1000; // a backstop only; the server calls a dead job in ~75 s
  var JOB_MAX_BUSY = 5;                 // "too many checks" this many times in a row gives up

  /* `job` is optional: pass {} and set job.cancelled = true to stop the checks
     for a result nobody wants any more. The promise then never settles. */
  function apiJob(path, opts, job) {
    job = job || {};
    return apiFetch(path, opts).then(function (res) {
      if (!res || !res.jobId) return res;
      if (job.onId) job.onId(res.jobId);
      return pollJob(res.jobId, job);
    });
  }

  function pollJob(jobId, job) {
    return new Promise(function (resolve, reject) {
      var timer = null;
      var inFlight = null; // the AbortController of the check in progress
      var busy = 0;
      var done = false;
      var expired = false;
      // A phone asleep past the backstop may come back to a finished job, so
      // the backstop only asks one last time; it fails only on "still running".
      var backstop = setTimeout(function () { expired = true; next(0); }, JOB_MAX_WAIT_MS);
      var tooLong = { error: 'This is taking far longer than it should. Please try again.' };

      function stop() {
        done = true;
        clearTimeout(timer);
        clearTimeout(backstop);
        if (inFlight) inFlight.abort();
        document.removeEventListener('visibilitychange', onVisible);
      }
      function succeed(body) { if (!done) { stop(); resolve(body); } }
      function fail(status, body) {
        if (done) return;
        stop();
        var err = new Error((body && body.error) || 'Request failed: ' + status);
        err.status = status;
        err.body = body || {};
        reject(err);
      }
      function next(ms) {
        if (done) return;
        clearTimeout(timer);
        timer = setTimeout(check, ms);
      }
      // A phone that wakes up asks at once, and drops whatever check was hanging.
      function onVisible() {
        if (document.visibilityState !== 'visible') return;
        if (inFlight) inFlight.abort();
        next(300);
      }
      function check() {
        if (done) return;
        if (job.cancelled) return stop();
        if (inFlight) inFlight.abort();
        var ctrl = new AbortController();
        inFlight = ctrl;
        var giveUp = setTimeout(function () { ctrl.abort(); }, JOB_CHECK_TIMEOUT_MS);
        // text/plain: no preflight, and the id stays out of the URL and the logs.
        // With the session cookie: a preview is readable only by the parent
        // who started it.
        fetch(API + '/api/jobs', withCredentials({
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: jobId,
          cache: 'no-store',
          signal: ctrl.signal
        }))
          .then(function (r) {
            return r.json().catch(function () { return null; }).then(function (data) {
              return { status: r.status, data: data };
            });
          })
          .then(function (x) {
            clearTimeout(giveUp);
            if (inFlight === ctrl) inFlight = null;
            if (done || ctrl.signal.aborted) return;
            if (x.status === 404) return fail(404, x.data);
            if (x.status === 429) {
              busy += 1;
              if (busy >= JOB_MAX_BUSY) return fail(429, x.data);
              var wait = x.data && x.data.retryAfter ? x.data.retryAfter * 1000 : JOB_POLL_MS * 4;
              return next(Math.min(Math.max(wait, JOB_POLL_MS), 60000));
            }
            busy = 0;
            var state = x.data && x.data.state;
            // Only a finished record with a status is an answer. Anything else --
            // running, a 503, a captive-portal page -- means ask again.
            if (state === 'finished' && typeof x.data.status === 'number') {
              if (x.data.status >= 200 && x.data.status < 300) return succeed(x.data.body);
              return fail(x.data.status, x.data.body);
            }
            if (expired) return fail(504, tooLong);
            next(JOB_POLL_MS);
          })
          .catch(function () {
            clearTimeout(giveUp);
            if (inFlight === ctrl) inFlight = null;
            if (expired) return fail(504, tooLong);
            next(JOB_POLL_MS);
          });
      }
      document.addEventListener('visibilitychange', onVisible);
      next(JOB_POLL_MS);
    });
  }

  /* Same shape, pointed at checkout-api. Kept separate so the two base URLs
     can never be confused at a call site. */
  function authFetch(path, opts) {
    var o = withCredentials(opts);
    o.headers = Object.assign({ 'Content-Type': 'application/json' }, (opts || {}).headers || {});
    return fetch(AUTH + path, o).then(function (r) {
      return r.text().then(function (body) {
        var data;
        try { data = JSON.parse(body); } catch (e) { data = { error: body }; }
        if (!r.ok) {
          var err = new Error(data.error || 'Request failed: ' + r.status);
          err.status = r.status;
          err.body = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------- step navigation ---------- */

  var LAST_INPUT_STEP = 5;

  /* A rate limit is not a failure. Say how long to wait, from the server's
     retryAfter (seconds) when it sends one. The draft is saved, so nothing
     they chose is lost. */
  function busyMessage(err) {
    var secs = err && err.body && Number(err.body.retryAfter);
    var mins = secs > 0 ? Math.max(1, Math.ceil(secs / 60)) : 0;
    var when = mins ? 'in about ' + mins + (mins === 1 ? ' minute' : ' minutes') : 'in a few minutes';
    return 'You have made a few books in a short time, so we have paused new ones for a moment. ' +
      'Everything you chose is saved. Tap Try Again ' + when + '.';
  }

  function canLeave(step) {
    if (step === 1) return state.cast.every(function (p) { return p.name.trim(); }) &&
      state.things.every(function (t) { return !thingProblem(t); });
    if (step === 2) return state.cast.every(function (p) { return p.gender; });
    if (step === 3) return !!state.theme || !!state.ownIdea.trim();
    if (step === 4) return !!state.look;
    // photoPath, not referenceId. The engine draws from the ORIGINAL photograph
    // on every page; referenceId is a drawn sheet the AI path never opens.
    // No session needed: the number is asked for on the drawing screen.
    if (step === 5) return state.cast.every(function (p) { return p.photoPath; }) &&
      state.things.every(function (t) { return t.photoPath; });
    return true;
  }

  function goToStep(n) {
    state.step = n;
    $$('.sb-step').forEach(function (s) {
      s.style.display = (+s.dataset.step === n) ? '' : 'none';
    });
    $$('.sb-progress__step').forEach(function (b, i) {
      var num = i + 1;
      b.classList.toggle('sb-progress__step--active', num === n);
      b.classList.toggle('sb-progress__step--completed', num < n);
      b.disabled = num > n;
    });
    var bar = $('.sb-progress');
    if (bar) bar.setAttribute('aria-valuenow', Math.min(n, LAST_INPUT_STEP));
    if (n === 2) renderAbout();
    if (n === 3) renderThemes();
    if (n === 4) renderLooks();
    if (n === 5) renderPhotos();
    if (n === 6) applySigninGate();
    setHeadings(n);
    renderSoFar();
    placeChat();
    var shown = $('.sb-step[data-step="' + n + '"]');
    if (shown) {
      shown.classList.remove('sb-step--enter');
      void shown.offsetWidth; // restart the entrance
      shown.classList.add('sb-step--enter');
    }
    // Nothing to scroll to on the way in -- the click handler has already put
    // the wizard at the top. Later steps still slide into view.
    if (root.dataset.awaitingStart !== 'true' && n > 1) {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    refreshGates();
    saveDraft();
  }

  /* Headings that use the child's name. "What does Yug love?" is a question a
     parent wants to answer; "What should it be about?" is a form. */
  function setHeadings(n) {
    var name = heroName();
    var many = state.cast.length > 1;
    function put(id, text) { var node = $(id); if (node) node.textContent = text; }
    if (n === 3) {
      put('#sb-themes-title', name ? 'What does ' + name + ' love?' : 'What should it be about?');
      put('#sb-themes-subtitle', 'Pick one. ' + (name || 'Your child') + ' is the hero of every story here.');
    }
    if (n === 4) put('#sb-look-title', name ? 'Pick a look for ' + possessive(name) + ' book' : 'How should it look?');
    if (n === 5) {
      var things = state.things.length > 0;
      put('#sb-photo-title', many || things ? 'Last thing. The photos.' : 'Last thing. A photo of ' + (name || 'them') + '.');
      put('#sb-photo-subtitle', things
        ? (many ? 'One clear photo of each face, and one of each favourite thing.' : 'One clear photo of their face, and one of each favourite thing.')
        : many ? 'One clear photo of each face. That is all we need.' : 'One clear photo of their face. That is all we need.');
      put('#sb-generate-label', name ? 'See ' + possessive(name) + ' Book' : 'See the Preview');
    }
  }

  /* The book so far: one strip that fills in as the parent goes, so five
     forms read as one thing being made. The title lands in it the moment luna
     has written the story. */
  function renderSoFar() {
    var box = $('#sb-sofar');
    if (!box) return;
    var h = hero(), name = heroName();
    box.hidden = !name || state.step < 2 || state.step > 6;
    if (box.hidden) return;
    var p = state.look ? currentPalette() : null;
    var cover = $('#sb-sofar-cover');
    cover.style.background = p ? p.cover : '';
    cover.style.color = p ? p.coverInk : '';
    $('#sb-sofar-initial').textContent = name.charAt(0).toUpperCase();
    $('#sb-sofar-title').textContent = state.story && state.story.title && state.step >= 4
      ? (state.story.titleName || name) + ' and the ' + state.story.title
      : possessive(name) + ' book';
    var bits = [];
    if (state.step > 2 && h.gender) bits.push('Age ' + h.age);
    if (state.theme) bits.push(state.theme.name);
    else if (state.ownIdea.trim() && state.step > 3) bits.push('Your own idea');
    if (p && state.step > 4) bits.push(p.name);
    var others = state.cast.slice(1).map(function (c) { return c.name.trim(); }).filter(Boolean);
    if (others.length) bits.push('with ' + others.join(', '));
    $('#sb-sofar-meta').textContent = bits.join(' · ');
  }

  /* A swipeable row. Scroll-snap does the moving; this adds the arrows, the
     dots and "which one is in the middle". The look cards and the sample book
     both use it. */
  function bindCarousel(track, prev, next, dots) {
    if (!track) return { go: function () {}, paint: function () {} };
    function slides() { return Array.prototype.slice.call(track.children); }
    function current() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, gap = Infinity;
      slides().forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
        if (d < gap) { gap = d; best = i; }
      });
      return best;
    }
    function go(i, instant) {
      var list = slides();
      var s = list[Math.max(0, Math.min(list.length - 1, i))];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: instant ? 'auto' : 'smooth' });
    }
    function paint() {
      var list = slides(), i = current();
      if (dots) {
        if (dots.children.length !== list.length) {
          dots.innerHTML = '';
          list.forEach(function (_, k) {
            var d = el('button', 'sb-dot');
            d.type = 'button';
            d.setAttribute('aria-label', 'Show ' + (k + 1) + ' of ' + list.length);
            d.addEventListener('click', function () { go(k); });
            dots.appendChild(d);
          });
        }
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('sb-dot--on', k === i); });
      }
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= list.length - 1;
    }
    var frame = null;
    track.addEventListener('scroll', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(paint);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    paint();
    return { go: go, paint: paint };
  }

  function refreshGates() {
    for (var s = 1; s <= LAST_INPUT_STEP; s++) {
      var btn = $('#sb-step' + s + '-next');
      if (btn) btn.disabled = !canLeave(s);
    }
    var gen = $('#sb-generate-btn');
    if (gen) gen.disabled = !canLeave(5);
  }

  /* ---------- step 1: who is in the book ---------- */

  /* Names that join the child's in the title, in cast order, only people still
     in the book and with a name typed. */
  function coHeroNames() {
    return state.cast.slice(1)
      .filter(function (p) { return state.coHeroIds.indexOf(p.id) >= 0 && p.name.trim(); })
      .map(function (p) { return p.name.trim(); });
  }

  function joinNames(names) {
    if (names.length <= 1) return names[0] || '';
    return names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1];
  }

  function renderTitleNames() {
    var wrap = $('#sb-titlenames');
    if (!wrap) return;
    state.coHeroIds = state.coHeroIds.filter(function (id) { return state.cast.some(function (p) { return p.id === id; }); });
    wrap.innerHTML = '';
    var star = el('button', 'sb-coverpick__opt sb-coverpick__opt--on', heroName() || 'The star');
    star.type = 'button'; star.disabled = true; star.setAttribute('aria-pressed', 'true');
    wrap.appendChild(star);
    state.cast.slice(1).forEach(function (p) {
      var on = state.coHeroIds.indexOf(p.id) >= 0;
      var b = el('button', 'sb-coverpick__opt' + (on ? ' sb-coverpick__opt--on' : ''), p.name.trim() || roleName(p.role));
      b.type = 'button';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.addEventListener('click', function () {
        var i = state.coHeroIds.indexOf(p.id);
        if (i >= 0) state.coHeroIds.splice(i, 1); else state.coHeroIds.push(p.id);
        saveDraft(); renderTitleNames();
      });
      wrap.appendChild(b);
    });
    var pv = $('#sb-titlepreview');
    if (pv) pv.textContent = (joinNames([heroName() || 'Your star'].concat(coHeroNames()))) + ' and the …';
  }

  function renderCoverPick() {
    var box = $('#sb-coverpick');
    if (!box) return;
    box.hidden = state.cast.length < 2;
    renderTitleNames();
    var h = $('#sb-coverpick-hero');
    if (h) h.textContent = 'Just ' + (heroName() || 'the star');
    $$('.sb-coverpick__opt', box).forEach(function (b) {
      var on = b.dataset.cover === state.cover;
      b.classList.toggle('sb-coverpick__opt--on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      if (!b.dataset.bound) {
        b.dataset.bound = '1';
        b.addEventListener('click', function () { state.cover = b.dataset.cover; state.coverChosen = true; saveDraft(); renderCoverPick(); });
      }
    });
  }

  function renderCast() {
    var wrap = $('#sb-characters');
    if (!wrap) return;
    wrap.innerHTML = '';

    state.cast.forEach(function (p, i) {
      var row = el('div', i === 0 ? 'sb-star' : 'sb-castrow');

      var field = el('div', 'sb-character-slot__field');
      var label = el('label', 'sb-character-slot__label', i === 0 ? 'Their first name' : roleName(p.role));
      label.htmlFor = 'sb-name-' + p.id;
      var name = el('input', 'sb-character-slot__input sb-character-slot__name');
      name.type = 'text';
      name.id = 'sb-name-' + p.id;
      name.maxLength = 50;
      name.autocomplete = 'off';
      name.value = p.name;
      name.placeholder = i === 0 ? 'e.g. Yug' : (CALLED[p.role] || 'Their first name');
      field.appendChild(label);
      field.appendChild(name);
      row.appendChild(field);

      if (i === 0) {
        // A small answer the moment a name is typed. It is the first sign that
        // this is about THEIR child and not a form.
        var cheer = el('p', 'sb-star__cheer');
        var paintCheer = function () {
          var n = p.name.trim();
          cheer.textContent = n ? n + ' goes on the cover.' : '';
          cheer.classList.toggle('sb-star__cheer--on', !!n);
        };
        name.addEventListener('input', function () { p.name = name.value; paintCheer(); refreshGates(); renderCoverPick(); });
        paintCheer();
        row.appendChild(cheer);
      } else {
        // Continue stays off until every person has a name. Say so, or the
        // button looks broken.
        var hint = el('p', 'sb-name-hint', 'Add a name so we know what to call them in the story.');
        var paintHint = function () { hint.hidden = !!p.name.trim(); };
        name.addEventListener('input', function () { p.name = name.value; paintHint(); refreshGates(); renderTitleNames(); });
        paintHint();
        field.appendChild(hint);
        var rm = el('button', 'sb-castrow__remove');
        rm.type = 'button';
        rm.setAttribute('aria-label', 'Remove ' + roleName(p.role));
        rm.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
        rm.addEventListener('click', function () {
          state.cast = state.cast.filter(function (x) { return x.id !== p.id; });
          // A choice made for people who are no longer in the book does not count.
          if (state.cast.length < 2) state.coverChosen = false;
          renderCast();
        });
        row.appendChild(rm);
      }
      wrap.appendChild(row);
    });

    // One tap per person. The role says who they are, so nobody is asked
    // whether a mum is a he or a she.
    var chips = $('#sb-castadd-chips');
    var full = state.cast.length >= MAX_PEOPLE;
    if (chips) {
      chips.innerHTML = '';
      ROLES.forEach(function (r) {
        if (r.key === 'hero') return;
        var b = el('button', 'sb-castadd__chip', r.name);
        b.type = 'button';
        b.disabled = full;
        b.addEventListener('click', function () {
          if (state.cast.length >= MAX_PEOPLE) return;
          var person = { id: nextId++, name: '', role: r.key, gender: IMPLIED[r.key] || '', age: null, photo: null, photoPath: null, referenceId: null };
          state.cast.push(person);
          renderCast();
          var input = document.getElementById('sb-name-' + person.id);
          if (input) input.focus();
        });
        chips.appendChild(b);
      });
    }
    var hint = $('#sb-castadd-hint');
    if (hint) hint.textContent = full ? 'That is as many as one story can hold.' : 'Optional. Tap to add.';
    refreshGates();
    renderCoverPick();
    renderThings();
  }

  function paintThingHints() {
    $$('.sb-thing-hint').forEach(function (hint) {
      var t = state.things.filter(function (x) { return String(x.id) === hint.dataset.thing; })[0];
      var problem = t ? thingProblem(t) : '';
      hint.textContent = problem;
      hint.hidden = !problem;
    });
  }

  /* The favourite things, after the people. Each is a name; its photo is asked
     at step 5. A parent who adds none is asked for no photo. */
  function renderThings() {
    var wrap = $('#sb-things');
    if (!wrap) return;
    wrap.innerHTML = '';
    state.things.forEach(function (t) {
      var row = el('div', 'sb-castrow');
      var field = el('div', 'sb-character-slot__field');
      var label = el('label', 'sb-character-slot__label', 'Favourite thing');
      label.htmlFor = 'sb-thing-' + t.id;
      var name = el('input', 'sb-character-slot__input sb-character-slot__name');
      name.type = 'text';
      name.id = 'sb-thing-' + t.id;
      name.maxLength = 40;
      name.autocomplete = 'off';
      name.value = t.name;
      name.placeholder = 'e.g. Red ride-on jeep';
      var hint = el('p', 'sb-name-hint sb-thing-hint');
      hint.dataset.thing = String(t.id);
      name.addEventListener('input', function () { t.name = name.value; paintThingHints(); refreshGates(); });
      field.appendChild(label);
      field.appendChild(name);
      field.appendChild(hint);
      row.appendChild(field);
      var rm = el('button', 'sb-castrow__remove');
      rm.type = 'button';
      rm.setAttribute('aria-label', 'Remove ' + (t.name.trim() || 'this thing'));
      rm.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      rm.addEventListener('click', function () {
        state.things = state.things.filter(function (x) { return x.id !== t.id; });
        renderThings();
        saveDraft();
      });
      row.appendChild(rm);
      wrap.appendChild(row);
    });
    paintThingHints();
    var full = state.things.length >= MAX_THINGS;
    var add = $('#sb-things-add');
    if (add) add.disabled = full;
    var hint = $('#sb-things-hint');
    if (hint) hint.textContent = full ? 'Two is plenty for one story.' : 'Optional. A toy, a bike, a ride-on car.';
    refreshGates();
  }

  /* ---------- step 2: age and gender ---------- */

  function renderAbout() {
    var wrap = $('#sb-about-rows');
    if (!wrap) return;
    wrap.innerHTML = '';

    // A draft saved before roles implied a pronoun may have a dad with none.
    state.cast.forEach(function (p) { if (!p.gender && IMPLIED[p.role]) p.gender = IMPLIED[p.role]; });

    var h = hero(), name = heroName();
    var title = $('#sb-about-title');
    if (title) title.textContent = name ? 'How old is ' + name + '?' : 'How old are they?';
    var sub = $('#sb-about-subtitle');
    if (sub) sub.textContent = (name ? possessive(name) : 'Their') + ' age picks the stories we show next, and how long the sentences run.';

    var card = el('div', 'sb-about-row sb-about-row--hero');
    var ages = el('div', 'sb-agepick');
    ages.setAttribute('role', 'radiogroup');
    ages.setAttribute('aria-label', 'Age');
    for (var a = 2; a <= 9; a++) (function (age) {
      var b = el('button', 'sb-agepick__age' + (h.age === age ? ' sb-agepick__age--on' : ''), String(age));
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', h.age === age ? 'true' : 'false');
      b.addEventListener('click', function () { h.age = age; state.band = null; renderAbout(); });
      ages.appendChild(b);
    })(a);
    card.appendChild(ages);
    card.appendChild(pronounAsk(h, 'In the story, ' + (name || 'your child') + ' is'));
    wrap.appendChild(card);

    state.cast.slice(1).forEach(function (p) {
      var sibling = p.role === 'brother' || p.role === 'sister';
      if (IMPLIED[p.role] && !sibling) return;
      var row = el('div', 'sb-about-row');
      var who = el('div', 'sb-about-row__who');
      who.appendChild(el('span', 'sb-about-row__name', p.name || roleName(p.role)));
      who.appendChild(el('span', 'sb-about-row__role', roleName(p.role)));
      row.appendChild(who);
      row.appendChild(sibling ? siblingAgeAsk(p) : pronounAsk(p, 'In the story, ' + (p.name.trim() || 'they') + ' is'));
      wrap.appendChild(row);
    });
    refreshGates();
  }

  /* Optional: big or little changes how a brother or sister plays and is drawn. */
  function siblingAgeAsk(p) {
    var box = el('div', 'sb-pronoun');
    box.appendChild(el('span', 'sb-character-slot__label', 'How old is ' + (p.name.trim() || (p.role === 'sister' ? 'she' : 'he')) + '?'));
    var ages = el('div', 'sb-agepick sb-agepick--sibling');
    ages.setAttribute('role', 'radiogroup');
    ages.setAttribute('aria-label', 'Age');
    var options = [[1, 'Baby']];
    for (var a = 2; a <= 12; a++) options.push([a, String(a)]);
    options.push([13, '13+']);
    options.forEach(function (o) {
      var on = p.age === o[0];
      var b = el('button', 'sb-agepick__age' + (on ? ' sb-agepick__age--on' : '') + (o[1].length > 3 ? ' sb-agepick__age--word' : ''), o[1]);
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.addEventListener('click', function () { p.age = on ? null : o[0]; renderAbout(); });
      ages.appendChild(b);
    });
    box.appendChild(ages);
    return box;
  }

  function pronounAsk(p, label) {
    var box = el('div', 'sb-pronoun');
    box.appendChild(el('span', 'sb-character-slot__label', label));
    var tiles = el('div', 'sb-gender');
    [['he', 'He'], ['she', 'She']].forEach(function (g) {
      var t = el('button', 'sb-gender-tile' + (p.gender === g[0] ? ' sb-gender-tile--selected' : ''), g[1]);
      t.type = 'button';
      t.setAttribute('aria-pressed', p.gender === g[0] ? 'true' : 'false');
      t.addEventListener('click', function () { p.gender = g[0]; renderAbout(); });
      tiles.appendChild(t);
    });
    box.appendChild(tiles);
    return box;
  }

  function roleName(key) {
    for (var i = 0; i < ROLES.length; i++) if (ROLES[i].key === key) return ROLES[i].name;
    return key;
  }

  /* ---------- step 3: the story theme ---------- */

  var subjectsExpanded = false;

  function renderThemes() {
    var h = hero();
    state.band = bandFor(h.age);

    // The band follows the age chosen at step 2. It used to have its own row
    // of tabs here, which asked the parent the same question twice.
    var rank = { };
    rank[h.gender] = 0; rank.both = 1;
    var ordered = SUBJECTS.slice().sort(function (a, b) {
      return (rank[a.lean] == null ? 2 : rank[a.lean]) - (rank[b.lean] == null ? 2 : rank[b.lean]);
    });
    var shown = subjectsExpanded ? ordered : ordered.slice(0, 8);
    fillGrid($('#sb-subjects-grid'), shown, 'subject');

    var more = $('#sb-subjects-more');
    if (more) {
      more.style.display = ordered.length > 8 ? '' : 'none';
      more.textContent = subjectsExpanded ? 'Show fewer' : 'Show ' + (ordered.length - 8) + ' more';
      more.onclick = function () { subjectsExpanded = !subjectsExpanded; renderThemes(); };
    }

    fillGrid($('#sb-situations-grid'), state.band.situations, 'situation');

    var own = $('#sb-own-idea');
    if (own && own.dataset.bound !== '1') {
      own.dataset.bound = '1';
      own.addEventListener('input', function () {
        state.ownIdea = own.value;
        if (own.value.trim()) { state.theme = null; markSelected(); }
        refreshGates();
      });
    }
    renderOwnChips();
    var ownNote = $('#sb-own-note');
    if (ownNote) ownNote.textContent = 'Whatever you type, we keep it to what a ' + h.age + ' year old can follow.';
    markSelected();
    refreshGates();
  }

  function fillGrid(grid, items, kind) {
    if (!grid) return;
    grid.innerHTML = '';
    items.forEach(function (item) {
      var card = el('button', 'sb-theme-card');
      card.type = 'button';
      card.dataset.kind = kind;
      card.dataset.key = item.key;

      // A small line drawing, not a picture. A 4:3 cover made every card about
      // 250px tall, so eight of them filled the screen and the parent had to
      // scroll to compare. The icon costs no height and gives the eye
      // something to find. It is our own static catalogue, so innerHTML is safe.
      if (item.icon) {
        var icon = el('span', 'sb-theme-card__icon');
        icon.innerHTML = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + item.icon + '</svg>';
        card.appendChild(icon);
      }
      var body = el('div', 'sb-theme-card__body');
      body.appendChild(el('h4', 'sb-theme-card__title', item.name));
      body.appendChild(el('p', 'sb-theme-card__desc', item.line));
      if (item.register) body.appendChild(el('span', 'sb-theme-card__age-badge', item.register));
      card.appendChild(body);

      card.addEventListener('click', function () {
        state.theme = { kind: kind, key: item.key, name: item.name };
        state.ownIdea = '';
        var own = $('#sb-own-idea');
        if (own) own.value = '';
        markSelected();
        refreshGates();
        renderSoFar();
        fetchTeasers();
      });
      grid.appendChild(card);
    });
  }

  function markSelected() {
    $$('.sb-theme-card').forEach(function (c) {
      var on = state.theme && c.dataset.kind === state.theme.kind && c.dataset.key === state.theme.key;
      c.classList.toggle('sb-theme-card--selected', !!on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function renderOwnChips() {
    var wrap = $('#sb-own-chips');
    if (!wrap) return;
    wrap.innerHTML = '';
    var chips = hero().gender === 'she'
      ? ['Horses', 'Cakes', 'The moon', 'Rainbows']
      : ['Diggers', 'Sharks', 'The moon', 'Football'];
    chips.forEach(function (c) {
      var b = el('button', 'sb-own__chip', c);
      b.type = 'button';
      b.addEventListener('click', function () {
        var input = $('#sb-own-idea');
        if (input) { input.value = c; input.dispatchEvent(new Event('input')); }
      });
      wrap.appendChild(b);
    });
    wrap.appendChild(el('span', 'sb-own__note', 'tap one, or write your own'));
  }

  /* ---------- five lines about this child, for the look cards ---------- */

  function themeText() { return state.theme ? state.theme.name : state.ownIdea.trim(); }

  /* Shown until luna answers, and for good if she does not. No theme words in
     these: a parent's own sentence does not drop into ours. */
  function localTeasers() {
    var n = heroName() || 'Little one';
    return [
      { shout: 'Go, ' + n + ', go!', line: n + ' runs to the gate. Something big is about to happen.' },
      { shout: 'One, two, three, ' + n + '!', line: n + ' counts to three, and the whole street goes quiet.' },
      { shout: 'Look, ' + n + ', look!', line: 'Up on the roof, ' + n + ' spots something nobody else can see.' },
      { shout: 'Hooray for ' + n + '!', line: 'Everyone claps, and ' + n + ' takes the biggest bow of the day.' },
      { shout: 'Goodnight, ' + n + '.', line: n + ' tucks the whole day under the pillow and smiles.' }
    ];
  }

  function teaserFor(i) {
    var list = state.teasers && state.teasers.length ? state.teasers : localTeasers();
    return list[i % list.length];
  }

  /* Asked the moment a theme is tapped, so the lines are there when the look
     cards open. About three seconds; never waited on, never an error. */
  function fetchTeasers() {
    var h = hero(), theme = themeText();
    if (!theme || !heroName() || !h.gender) return;
    var key = [heroName(), h.age, h.gender, theme].join('|');
    if (state.teaserKey === key) return;
    state.teaserKey = key;
    state.teasers = null;
    var ctrl = new AbortController();
    var giveUp = setTimeout(function () { ctrl.abort(); }, 12000);
    apiFetch('/api/story/teaser', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: heroName(), age: h.age, gender: h.gender, theme: theme }),
      signal: ctrl.signal
    })
      .then(function (res) {
        clearTimeout(giveUp);
        if (state.teaserKey !== key || !res || !Array.isArray(res.lines) || !res.lines.length) return;
        state.teasers = res.lines;
        if (state.step === 4) paintTeasers();
      })
      .catch(function () { clearTimeout(giveUp); });
  }

  function paintTeasers() {
    $$('.sb-look-card').forEach(function (card, i) {
      var t = teaserFor(i);
      var shout = card.querySelector('.sb-look-card__shout');
      var line = card.querySelector('.sb-look-card__line');
      if (shout) shout.textContent = t.shout;
      if (line) line.textContent = t.line;
      card.classList.remove('sb-look-card--fresh');
      void card.offsetWidth;
      card.classList.add('sb-look-card--fresh');
    });
  }

  /* ---------- the story, started early ---------- */

  function storyKey() {
    var h = hero();
    return [h.name, h.age, h.gender,
            state.theme ? state.theme.kind + ':' + state.theme.key : '',
            state.ownIdea.trim(),
            coverApplies() ? state.cover : '',
            coHeroNames().join(','),
            // A new name, role or age for anyone else is a different story too.
            state.cast.slice(1).map(function (p) { return [p.name, p.role, p.gender, personAge(p)].join(':'); }).join(','),
            thingNames().map(function (t) { return t.name; }).join(',')].join('|');
  }

  function startStory() {
    var key = storyKey();
    if (state.storyPromise && state.storyKey === key) return; // nothing changed
    var h = hero();
    // A story for the old choices is no use. Stop asking after it, and never let
    // it land on top of the new one.
    if (state.storyJob) state.storyJob.cancelled = true;
    var job = state.storyJob = {
      onId: function (id) { if (state.storyKey === key) { state.storyJobId = id; saveDraft(); } }
    };
    state.storyKey = key;
    state.story = null;
    state.storyJobId = null;
    state.storyPromise = apiJob('/api/story/write', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        hero: { name: h.name, role: 'hero', gender: h.gender, age: h.age },
        others: state.cast.slice(1).map(function (p) {
          return { name: p.name, role: p.role, gender: p.gender, age: personAge(p) };
        }),
        theme: state.theme ? state.theme.name : null,
        themeLine: state.theme ? (state.theme.line || '') : '',
        ownIdea: state.ownIdea.trim() || null,
        cover: coverApplies() ? state.cover : undefined,
        coHeroes: coHeroNames(),
        things: thingNames(),
        background: true
      })
    }, job)
      .then(function (res) {
        if (state.storyKey === key) { state.story = res; state.storyError = null; saveDraft(); renderSoFar(); placeChat(); }
        return res;
      })
      .catch(function (err) {
        // Never block the flow on this. The preview falls back to generating
        // the story alongside the pictures if it is missing. Keep the error:
        // a rate limit has to reach the parent as "wait a few minutes", not
        // as "we could not write the story".
        console.warn('[storybook] early story write failed:', err);
        if (state.storyKey === key) { state.story = null; state.storyError = err; }
        return null;
      });
  }

  /* ---------- step 4: how it looks ---------- */

  function paletteOrder() {
    var h = hero();
    function fits(p) { var r = p.ages.split('-'); return h.age >= +r[0] && h.age <= +r[1]; }
    function centre(p) { var r = p.ages.split('-'); return Math.abs(h.age - (+r[0] + +r[1]) / 2); }
    return PALETTES.slice().sort(function (a, b) {
      if (fits(a) !== fits(b)) return fits(a) ? -1 : 1;
      var la = a.lean === h.gender ? 0 : (a.lean === 'both' ? 1 : 2);
      var lb = b.lean === h.gender ? 0 : (b.lean === 'both' ? 1 : 2);
      if (la !== lb) return la - lb;
      return centre(a) - centre(b);
    });
  }

  function renderLooks() {
    var wrap = $('#sb-looks');
    if (!wrap) return;
    var ordered = paletteOrder();
    if (!state.look) state.look = ordered[0].key;

    wrap.innerHTML = '';
    ordered.forEach(function (p, i) {
      var t = teaserFor(i);
      var card = el('button', 'sb-look-card' + (state.look === p.key ? ' sb-look-card--selected' : ''));
      card.type = 'button';
      card.dataset.look = p.key;
      card.setAttribute('aria-pressed', state.look === p.key ? 'true' : 'false');

      // The cover colour fills the top of the card, so no two looks can be
      // mistaken for each other: navy, pink, yellow, sage, black. Before this
      // every card opened on a cream panel and three of five looked the same.
      var cover = el('div', 'sb-look-card__cover');
      cover.style.background = p.cover;
      cover.style.color = p.coverInk;
      var shout = el('div', 'sb-look-card__shout', t.shout);
      shout.style.fontFamily = p.dfam;
      shout.style.letterSpacing = p.dls;
      cover.appendChild(shout);
      card.appendChild(cover);

      var page = el('div', 'sb-look-card__page');
      page.style.background = p.panel;
      page.style.color = p.ink;
      var line = el('p', 'sb-look-card__line', t.line);
      line.style.fontFamily = p.bfam;
      page.appendChild(line);
      var rule = el('span', 'sb-look-card__rule');
      rule.style.background = p.accent;
      page.appendChild(rule);
      card.appendChild(page);

      var info = el('div', 'sb-look-card__info');
      var head = el('div', 'sb-look-card__head');
      head.appendChild(el('h4', 'sb-look-card__title', p.name));
      head.appendChild(el('span', 'sb-look-card__tick', 'Selected'));
      info.appendChild(head);
      info.appendChild(el('p', 'sb-look-card__why', p.why));
      var sw = el('div', 'sb-look-card__swatches');
      p.swatches.forEach(function (hex) {
        var dot = el('span', 'sb-look-card__swatch');
        dot.style.background = hex;
        sw.appendChild(dot);
      });
      info.appendChild(sw);
      info.appendChild(el('p', 'sb-look-card__art', 'Illustrated in ' + p.art.toLowerCase()));
      card.appendChild(info);

      card.addEventListener('click', function () { selectLook(p.key); });
      wrap.appendChild(card);
    });

    // Open on the chosen card, once the row has a width to measure.
    requestAnimationFrame(function () {
      var index = ordered.map(function (p) { return p.key; }).indexOf(state.look);
      if (state.looksCarousel) { state.looksCarousel.go(index, true); state.looksCarousel.paint(); }
    });
    refreshGates();
  }

  function selectLook(key) {
    state.look = key;
    $$('.sb-look-card').forEach(function (card, i) {
      var on = card.dataset.look === key;
      card.classList.toggle('sb-look-card--selected', on);
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && state.looksCarousel) state.looksCarousel.go(i);
    });
    renderSoFar();
    refreshGates();
  }

  function currentPalette() {
    for (var i = 0; i < PALETTES.length; i++) if (PALETTES[i].key === state.look) return PALETTES[i];
    return PALETTES[0];
  }

  /* ---------- step 5: the photo ---------- */

  function renderPhotos() {
    var wrap = $('#sb-photo-rows');
    if (!wrap) return;
    wrap.innerHTML = '';

    state.cast.forEach(function (p, i) {
      wrap.appendChild(photoSlot(p,
        (p.name || 'Person ' + (i + 1)) + (i === 0 ? ' · the star' : ' · ' + roleName(p.role)),
        'Add ' + possessive(p.name.trim() || 'their') + ' photo', FACE_ICON));
    });
    // A slot only for a thing the parent added at step 1.
    state.things.forEach(function (t) {
      wrap.appendChild(photoSlot(t, t.name.trim() + ' · favourite thing', 'Add a photo of it', THING_ICON));
    });
    refreshGates();
  }

  var FACE_ICON = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="24" cy="20" r="9"></circle><path d="M8 42c2-9 8-13 16-13s14 4 16 13"></path><path d="M20 21c1.5 2 6.500 2 8 0"></path></svg>';
  var THING_ICON = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M24 7l5 10.5 11.5 1.6-8.3 8 2 11.4L24 33l-10.2 5.5 2-11.4-8.3-8 11.5-1.6z"></path></svg>';

  function photoSlot(p, title, prompt, icon) {
    var slot = el('div', 'sb-character-slot');
    var head = el('div', 'sb-character-slot__header');
    head.appendChild(el('span', 'sb-character-slot__number', title));
    slot.appendChild(head);

    var zone = el('div', 'sb-photo-zone' + (p.photo ? ' sb-photo-zone--filled' : ''));
    var input = el('input', 'sb-photo-zone__input');
    input.type = 'file';
    input.accept = 'image/jpeg,image/png,image/webp';
    input.id = 'sb-photo-' + p.id;

    var placeholder = el('div', 'sb-photo-zone__placeholder');
    var face = el('span', 'sb-photo-zone__face');
    face.innerHTML = icon;
    placeholder.appendChild(face);
    placeholder.appendChild(el('span', 'sb-photo-zone__text', prompt));
    placeholder.appendChild(el('span', 'sb-photo-zone__hint', 'Tap to choose. JPG, PNG or WebP.'));

    var loading = el('div', 'sb-photo-zone__loading');
    loading.style.display = 'none';
    loading.appendChild(el('div', 'sb-spinner sb-spinner--small'));

    var preview = el('div', 'sb-photo-zone__preview');
    preview.style.display = p.photo ? '' : 'none';
    var thumb = el('img', 'sb-photo-zone__thumbnail');
    if (p.photo) thumb.src = p.photo;
    thumb.alt = 'Photo of ' + (p.name || 'this person');
    var change = el('button', 'sb-photo-zone__change', 'Change photo');
    change.type = 'button';
    change.addEventListener('click', function (e) { e.stopPropagation(); input.click(); });
    preview.appendChild(thumb);
    preview.appendChild(el('span', 'sb-photo-zone__ok', 'Looks great'));
    preview.appendChild(change);

    if (p.photo) placeholder.style.display = 'none';

    zone.appendChild(input);
    zone.appendChild(placeholder);
    zone.appendChild(loading);
    zone.appendChild(preview);

    // The input is an invisible layer over the whole zone, so a tap on it
    // already opens the picker. Only open it for taps that land elsewhere,
    // or iOS gets two open requests from one tap.
    zone.addEventListener('click', function (e) { if (e.target === input) return; if (!p.photo) input.click(); });
    zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.classList.add('sb-photo-zone--dragover'); });
    zone.addEventListener('dragleave', function () { zone.classList.remove('sb-photo-zone--dragover'); });
    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      zone.classList.remove('sb-photo-zone--dragover');
      if (e.dataTransfer.files[0]) handleFile(p, e.dataTransfer.files[0], zone, placeholder, loading, preview, thumb);
    });
    input.addEventListener('change', function () {
      if (input.files[0]) handleFile(p, input.files[0], zone, placeholder, loading, preview, thumb);
    });

    slot.appendChild(zone);
    return slot;
  }

  /* A phone photo is a 4-8 MB JPEG at 24 MP and 10-20 MB at 48 MP. The API
     host refuses any request over 4.5 MB before our code runs, and that
     refusal carries no CORS header, so the browser reports it as a network
     failure with no status -- the parent was told "our side", and retried the
     same photo forever. Shrink here first: the engine never needs more than
     ~2000 px. Drawing through a canvas also converts HEIC (Safari decodes it)
     and bakes the rotation tag into the pixels, so the child is never drawn
     sideways. If the browser cannot decode the file, send it unchanged and let
     the server explain. */
  var PHOTO_MAX_EDGE = 2048;
  var PHOTO_JPEG_QUALITY = 0.86;
  var PHOTO_MAX_ORIGINAL_BYTES = 30 * 1024 * 1024;

  function shrinkPhoto(file) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      function done(result) { URL.revokeObjectURL(url); resolve(result); }
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          if (!w || !h) return done(file);
          var scale = Math.min(1, PHOTO_MAX_EDGE / Math.max(w, h));
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(w * scale);
          canvas.height = Math.round(h * scale);
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(function (blob) {
            if (!blob) return done(file);
            var name = (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
            done(new File([blob], name, { type: 'image/jpeg' }));
          }, 'image/jpeg', PHOTO_JPEG_QUALITY);
        } catch (e) {
          done(file);
        }
      };
      img.onerror = function () { done(file); };
      img.src = url;
    });
  }

  function handleFile(person, file, zone, placeholder, loading, preview, thumb) {
    var err = zone.parentNode.querySelector('.sb-error');
    if (err) err.remove();
    if (file.size > PHOTO_MAX_ORIGINAL_BYTES) return showPhotoError(zone, 'That file is over 30 MB. Try a smaller one.');

    placeholder.style.display = 'none';
    preview.style.display = 'none';
    loading.style.display = '';

    shrinkPhoto(file)
      .then(function (photo) {
        person.photo = URL.createObjectURL(photo);
        thumb.src = person.photo;

        var fd = new FormData();
        fd.append('photo', photo, photo.name || 'photo.jpg');
        // A favourite thing has no face to check: it goes to its own upload.
        if (person.kind === 'thing') {
          fd.append('name', person.name.trim());
          return apiFetch('/api/thing/photo', { method: 'POST', body: fd });
        }
        fd.append('name', person.name || 'Character');
        fd.append('role', person.role);
        fd.append('gender', person.gender);
        if (person === hero()) fd.append('age', String(person.age));
        // The engine never opens the drawn reference sheet, so drawing one costs a
        // paid image call and about twenty seconds of this parent's wait. The face
        // check still runs -- that is the part that protects them.
        fd.append('skipReference', '1');

        return apiFetch('/api/character/preview', { method: 'POST', body: fd });
      })
      .then(function (res) {
        var data = res.data || res;
        // photoPath is the ORIGINAL photograph in storage. It is what every
        // page is drawn from. referenceId is a drawing and must never stand in
        // for it -- drawing from a drawing is what put three different boys in
        // one book.
        person.photoPath = data.photoPath || null;
        person.referenceId = data.referenceId || null;
        if (!person.photoPath) throw new Error('no photo path returned');
        makeThumb(person.photo).then(function (t) { person.thumb = t; saveDraft(); });
        loading.style.display = 'none';
        preview.style.display = '';
        refreshGates();
      })
      .catch(function (err) {
        loading.style.display = 'none';
        placeholder.style.display = '';
        person.photo = null;
        person.photoPath = null;
        person.referenceId = null;

        var status = err && err.status;
        var message;
        if (status === 401 || status === 403) {
          // Not a photo problem. Say so, or the parent retakes photos forever.
          // The session lapsed mid-flow, so put the gate back up.
          state.session = null;
          state.sessionChecked = true;
          applySigninGate();
          message = 'Your sign-in expired. Enter your number again and we will carry on.';
        } else if (status === 413 || !status) {
          // No status means the browser never got an answer it could read: a
          // dropped connection, or the host's 4.5 MB refusal, which carries no
          // CORS header. Either way the photo did not arrive. Do not blame
          // "our side" -- that sends the parent back to the same photo.
          message = 'That photo did not reach us. Check your connection and try again, or pick a smaller photo.';
        } else if (status === 429) {
          message = 'Too many tries just now. Give it a minute and upload again.';
        } else if (status >= 500) {
          message = 'Something went wrong on our side, not with your photo. Please try again.';
        } else {
          // The API says why in plain words: no face, two faces, a format it
          // cannot open. Use that; a fixed "face" line is wrong for the others.
          message = (err && err.body && typeof err.body.error === 'string' && err.body.error) ||
            ('We cannot see ' + (person.gender === 'she' ? 'her' : 'their') +
            ' face clearly enough. Try a photo taken front-on, in good light.');
        }
        console.error('[storybook] photo upload failed', status, err && err.body);
        showPhotoError(zone, message);
        refreshGates();
      });
  }

  function showPhotoError(zone, message) {
    var box = el('div', 'sb-error');
    box.appendChild(el('p', 'sb-error__text', message));
    zone.parentNode.appendChild(box);
  }

  /* ---------- sign-in ---------- */

  /* Asks the STORYBOOK api whether it accepts this browser's session -- not
     checkout-api. The cookie is httpOnly so JS cannot read it, and only the app
     that is about to spend money on a picture can say whether it will honour
     it. Asking the issuer instead once hid a JWT_SECRET drift between the two
     apps: every OTP succeeded, every upload 401'd. */
  function checkSession(force) {
    if (state.sessionChecked && !force) return Promise.resolve(state.session);
    return apiFetch('/api/session/check', { method: 'GET' })
      .then(function (data) {
        state.session = { phone: data.phone, shopifyCustomerId: data.shopifyCustomerId || null };
        state.sessionBroken = false;
        return state.session;
      })
      .catch(function (err) {
        state.session = null;
        // A 500 is our fault, not theirs. Say so rather than asking them to
        // sign in again at a door that is not going to open.
        state.sessionBroken = (err && err.status >= 500);
        return null;
      })
      .then(function (session) {
        state.sessionChecked = true;
        applySigninGate();
        return session;
      });
  }

  function signinPane(name) {
    $$('[data-sb-pane]').forEach(function (pane) {
      pane.hidden = pane.dataset.sbPane !== name;
    });
  }

  function signinError(message) {
    var box = $('#sb-signin-error'), txt = $('#sb-signin-error-text');
    if (!box || !txt) return;
    if (!message) { box.style.display = 'none'; return; }
    txt.textContent = message;
    box.style.display = '';
  }

  /* The number is asked for on the drawing screen, while the book is drawn
     (Sahil, 22 Sep 2026): the photos come first, so the wait for the pictures
     and the wait for the code overlap. A book that finishes first is held
     until the code is in, then opened. */
  function applySigninGate() {
    var gate = $('#sb-signin');
    var signedIn = !!state.session;
    if (gate) gate.hidden = signedIn || state.step !== 6;
    // The number first (Sahil, 5 Oct 2026): until the code is in, the story
    // is locked under the number box; after it, the story is the screen.
    var step = $('[data-step="6"]');
    if (step) step.classList.toggle('sb-step--reading', signedIn);
    lockReader();
    if (state.step === 6) showReaderPage(state.readerIndex);
    placeChat();
    refreshGates();
    if (signedIn) flushSave(); // a save held back by a lapsed sign-in
    if (signedIn && state.heldPreview) {
      var held = state.heldPreview;
      state.heldPreview = null;
      makeReady(held);
    }
  }

  function busy(btn, on, label) {
    if (!btn) return;
    btn.disabled = on;
    var text = btn.querySelector('.sb-btn__text');
    var load = btn.querySelector('.sb-btn__loading');
    if (text && label) text.textContent = label;
    if (load) load.style.display = on ? '' : 'none';
    if (text) text.style.display = on ? 'none' : '';
  }

  function sendCode(resend) {
    var cc = $('#sb-phone-cc'), input = $('#sb-phone-input');
    var digits = (input && input.value || '').replace(/\D/g, '');
    if (digits.length < 7) return signinError('That number looks short. Check it and try again.');
    signinError('');

    var btn = resend ? $('#sb-otp-resend') : $('#sb-phone-send');
    busy(btn, true, 'Sending');
    state.otpPhone = (cc ? cc.value : '+91') + digits;

    authFetch('/api/otp/send', {
      method: 'POST',
      body: JSON.stringify({ countryCode: cc ? cc.value : '+91', phone: digits })
    })
      .then(function (data) {
        busy(btn, false, 'Send the code');
        state.otpSessionId = data.sessionId;
        var to = $('#sb-otp-to');
        if (to) to.textContent = state.otpPhone;
        signinPane('otp');
        var otp = $('#sb-otp-input');
        if (otp) { otp.value = ''; otp.focus(); }
      })
      .catch(function (err) {
        busy(btn, false, 'Send the code');
        signinError(err.status === 429
          ? 'That is a few too many codes. Give it ten minutes.'
          : (err.message || 'We could not send the code. Try again.'));
      });
  }

  function verifyCode() {
    var input = $('#sb-otp-input');
    var code = (input && input.value || '').replace(/\D/g, '');
    if (code.length !== 6) return signinError('The code is six digits.');
    signinError('');

    var btn = $('#sb-otp-verify');
    busy(btn, true, 'Verifying');

    authFetch('/api/otp/verify', {
      method: 'POST',
      body: JSON.stringify({ sessionId: state.otpSessionId, otp: code, phone: state.otpPhone })
    })
      .then(function () {
        // The JWT arrives as an httpOnly cookie on .macmerise.com, never in
        // this response. Nothing to store -- the browser carries it from here.
        //
        // A verified code is NOT proof the photo will upload. Confirm with the
        // storybook api before opening the photo step, or a parent walks into
        // a 401 holding a picture of their child.
        return checkSession(true).then(function (session) {
          busy(btn, false, 'Verify');
          if (session) return;
          signinError(state.sessionBroken
            ? 'Your number is verified, but something is wrong on our side. Please call us on +91 7279999888 and we will take it from here.'
            : 'Your number is verified but the sign-in did not carry over. Please reload the page and try once more.');
          console.error('[storybook] OTP verified but /api/session/check refused the session');
        });
      })
      .catch(function (err) {
        busy(btn, false, 'Verify');
        signinError(err.status === 401
          ? 'That code did not match. Check it, or ask for a new one.'
          : (err.message || 'We could not verify that code. Try again.'));
      });
  }

  function bindSignin() {
    var send = $('#sb-phone-send');
    if (send) send.addEventListener('click', function () { sendCode(false); });

    var verify = $('#sb-otp-verify');
    if (verify) verify.addEventListener('click', verifyCode);

    var resend = $('#sb-otp-resend');
    if (resend) resend.addEventListener('click', function () { sendCode(true); });

    var change = $('#sb-otp-change');
    if (change) change.addEventListener('click', function () {
      signinError('');
      signinPane('phone');
      var input = $('#sb-phone-input');
      if (input) input.focus();
    });

    // Enter submits whichever pane is open.
    var phone = $('#sb-phone-input');
    if (phone) phone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); sendCode(false); }
    });
    var otp = $('#sb-otp-input');
    if (otp) otp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); verifyCode(); }
    });
  }

  /* ---------- drawing and preview ---------- */

  function startGenerate() { drawBook(null); }

  /* resumeJobId: a preview job started before the tab was reloaded. Its result
     is fetched, not drawn again. */
  function drawBook(resumeJobId) {
    goToStep(6);
    var p = currentPalette();
    var make = $('#sb-make');
    if (make) {
      make.style.setProperty('--sb-bloom-1', p.swatches[0]);
      make.style.setProperty('--sb-bloom-2', p.swatches[1]);
      make.style.setProperty('--sb-bloom-3', p.swatches[2]);
      make.style.setProperty('--sb-make-paper', p.panel);
      make.style.setProperty('--sb-make-ink', p.ink);
    }
    state.readyPreview = null;
    var status = $('#sb-make .sb-make__status'), ready = $('#sb-make-ready');
    if (status) status.hidden = false;
    if (ready) ready.hidden = true;
    var gateTitle = $('#sb-signin-title');
    if (gateTitle) gateTitle.textContent = 'Add your number to start reading ' + (heroName() ? possessive(heroName()) : 'the') + ' story.';
    var title = $('#sb-generating-title');
    if (title) title.textContent = 'Creating ' + (heroName() ? possessive(heroName()) : 'your') + ' book';
    startReader();

    // A retry starts a second ticker unless the first is stopped, and two of
    // them fight over the same text.
    if (state.ticker) { clearInterval(state.ticker); state.ticker = null; }
    // Same for the drawing a retry replaces: stop asking after it, so a late
    // answer cannot land on top of this one.
    if (state.previewJob) state.previewJob.cancelled = true;
    // A new run makes a new book record from the story and the people as they
    // are now, changes included. A save waiting for the old record would only
    // be refused by the new one.
    if (!resumeJobId) {
      state.pendingSave = null;
      state.generationId = null;
      state.editKey = null;
      state.outOfSync = false;
    }
    var previewJob = state.previewJob = {
      onId: function (id) { state.previewJobId = id; saveDraft(); }
    };

    var started = Date.now();
    function tick() {
      // The server only says "running" or "finished", so this is an estimate:
      // quick at first, slower near the end, never past 95% on its own.
      var t = (Date.now() - started) / MAKE_EXPECT_MS;
      setMake(Math.min(0.95, 1 - Math.exp(-2.6 * t)));
    }
    tick();
    state.ticker = setInterval(tick, 1000);
    var ticker = state.ticker;

    // The story is normally already written by now. Wait on it if not -- and if
    // the step 3 write failed outright, write it here instead of drawing a book
    // with no words in it. The backend has no story of its own to fall back on.
    Promise.resolve(resumeJobId ? null : state.storyPromise)
      .then(function () {
        if (resumeJobId || state.story) return state.story;
        // startStory() short-circuits when nothing has changed, so clear the
        // key first or the retry hands back the same failed promise.
        state.storyKey = null;
        startStory();
        return state.storyPromise;
      })
      .then(function () {
        if (resumeJobId) return pollJob(resumeJobId, previewJob);
        if (!state.story) {
          if (state.storyError && state.storyError.status === 429) throw state.storyError;
          throw new Error('We could not write the story. Please try again in a minute.');
        }
        // The story was still being written when the painting screen opened.
        var reader = $('#sb-reader');
        if (reader && reader.hidden) startReader();
        placeChat();
        // The book record is made from this story and these people.
        state.saved = { story: state.story, cast: cloneCast(), saves: 0 };
        return apiJob('/api/book/generate-preview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        // themeSlug, not themeId. themeId is a storybook_themes UUID and this
        // catalogue has no row there; sending the key as themeId was a 400.
        themeSlug: state.theme ? state.theme.key : undefined,
        themeKind: state.theme ? state.theme.kind : 'own',
        ownIdea: state.ownIdea || null,
        look: state.look,
        band: state.band ? state.band.key : null,
        dedicationText: (document.getElementById('sb-dedication-text') || {}).value || undefined,
        characters: state.cast.map(function (c) {
          return {
            role: c.role,
            name: c.name,
            // The wizard stores he/she because that is what it says to a
            // parent. The API draws boys and girls. Translate at the boundary
            // rather than making either side speak the other's language.
            gender: c.gender === 'she' ? 'girl' : 'boy',
            // The hero, a twin and a brother or sister with a picked age have
            // one. Omit it for everyone else instead of sending null.
            age: personAge(c),
            photoUrl: c.photoPath,
            referenceId: c.referenceId || undefined
          };
        }),
        // Each favourite thing with its photo: drawn wherever a scene names it.
        things: state.things.map(function (t) { return { name: t.name.trim(), photoUrl: t.photoPath }; }),
        // Written at step 3 and posted back so the backend only draws pictures.
        story: state.story || null,
        background: true
      })
        }, previewJob);
      })
      .then(function (res) {
        clearInterval(ticker);
        state.ticker = null;
        noteBook(res);
        if (!state.session) {
          // Created before the code is in. Keep it; applySigninGate opens it.
          // The number comes first, so this screen never says "ready".
          state.heldPreview = res;
          var sub = $('#sb-generating-subtitle');
          if (sub) sub.textContent = 'Add your number to see it. We will send you the link too.';
          $$('[data-elapsed]').forEach(function (n) { n.textContent = 'Add your number to see it'; });
          var left = $('#sb-make-left');
          if (left) left.textContent = '';
          return;
        }
        makeReady(res);
      })
      .catch(function (e) {
        clearInterval(ticker);
        state.ticker = null;
        // A failed job is not worth resuming after a reload; Try again starts a new one.
        state.previewJobId = null;
        saveDraft();
        $$('[data-elapsed]').forEach(function (n) { n.textContent = 'Stopped'; });
        var box = $('#sb-generation-error');
        var txt = $('#sb-generation-error-text');
        // The API says WHY in the body. Showing "Request failed: 400" instead
        // threw that away and made every failure look identical.
        var reason = (e && e.body && (e.body.error || e.body.message)) || e.message;
        if (txt) txt.textContent = e && e.status === 429 ? busyMessage(e) : 'Something went wrong drawing the book. ' + reason;
        if (box) box.style.display = '';
        console.error('[storybook] generate failed', e && e.status, e && e.body);
      });
  }

  /* The book being created: pencil lines, then the look's colours, as p
     rises from 0 to 1. Each [data-at] part switches on once p passes it. */
  var MAKE_EXPECT_MS = 180000;

  function setMake(p) {
    var i = p < 0.18 ? 0 : p < 0.45 ? 1 : p < 0.8 ? 2 : 3;
    // Above the story the row names the book; under the number box it says
    // what is happening.
    var label = state.session
      ? 'Creating ' + (heroName() ? possessive(heroName()) : 'your') + ' book'
      : ['Studying the photo', 'Sketching ' + (heroName() || 'the hero'), 'Adding colour', 'Finishing touches'][i];
    var make = $('#sb-make');
    if (make) make.style.setProperty('--sb-make-p', p);
    $$('#sb-make [data-at]').forEach(function (n) { n.classList.toggle('is-on', p >= Number(n.getAttribute('data-at'))); });
    $$('[data-elapsed]').forEach(function (n) { n.textContent = label; });
    var left = $('#sb-make-left');
    if (left) left.textContent = p > 0.85 ? 'almost there' : 'about ' + Math.max(1, Math.ceil((1 - p) * 3)) + ' min left';
    var track = $('#sb-make .sb-make__track');
    if (track) track.setAttribute('aria-valuenow', String(Math.round(p * 100)));
  }

  /* Created, with the code in. The parent may be in the middle of a page, so
     the row offers the pictures instead of jumping to them. */
  function makeReady(res) {
    state.readyPreview = res;
    setMake(1);
    var status = $('#sb-make .sb-make__status'), ready = $('#sb-make-ready');
    if (status) status.hidden = true;
    if (ready) ready.hidden = false;
    var title = $('#sb-make-ready-title');
    if (title) title.textContent = heroName() ? possessive(heroName()) + ' book is ready' : 'Your book is ready';
  }

  function storyTitle() {
    var name = heroName();
    return state.story && state.story.title
      ? (state.story.titleName || name) + ' and the ' + state.story.title
      : possessive(name) + ' book';
  }

  /* The whole story, to read while the pictures are created, in the chosen
     look's paper, ink and lettering (Sahil, 5 Oct 2026). The parent turns the
     pages. Until the code is in it is locked to the first lines. */
  function showReaderPage(k) {
    var spreads = state.story && state.story.spreads || [];
    if (!spreads.length) return;
    if (!state.session) k = 0;
    state.readerIndex = Math.max(0, Math.min(spreads.length - 1, k));
    var text = $('#sb-reader-text');
    if (text) {
      text.classList.remove('sb-reader__text--in');
      void text.offsetWidth;
      text.textContent = String(spreads[state.readerIndex].text).trim();
      text.classList.add('sb-reader__text--in');
    }
    var count = $('#sb-reader-count');
    if (count) count.textContent = 'Page ' + (state.readerIndex + 1) + ' of ' + spreads.length;
    $$('#sb-reader-dots .sb-dot').forEach(function (d, i) { d.classList.toggle('sb-dot--on', i === state.readerIndex); });
    var prev = $('#sb-reader-prev'), next = $('#sb-reader-next');
    if (prev) prev.disabled = state.readerIndex === 0;
    if (next) next.disabled = state.readerIndex >= spreads.length - 1;
  }

  function startReader() {
    var box = $('#sb-reader');
    if (!box) return;
    var spreads = state.story && state.story.spreads || [];
    box.hidden = !spreads.length;
    if (!spreads.length) return;

    var p = currentPalette();
    var page = $('#sb-reader-page');
    if (page) {
      page.style.background = p.panel;
      page.style.color = p.ink;
      page.style.setProperty('--sb-reader-accent', p.accent);
    }
    var text = $('#sb-reader-text');
    if (text) text.style.fontFamily = p.bfam;
    var title = $('#sb-reader-title');
    if (title) {
      title.textContent = storyTitle();
      title.style.fontFamily = p.dfam;
      title.style.letterSpacing = p.dls;
    }
    var dots = $('#sb-reader-dots');
    if (dots) {
      dots.innerHTML = '';
      spreads.forEach(function () { dots.appendChild(el('span', 'sb-dot')); });
    }
    lockReader();
    showReaderPage(0);
  }

  function lockReader() {
    var box = $('#sb-reader');
    if (box) box.classList.toggle('sb-reader--locked', !state.session);
  }

  /* ---------- the story, changed in the parent's own words ---------- */

  /* Sahil, 5 Oct 2026: after the code is in, up to three changes a book. A
     change that names someone new asks for them in the chat: who they are, an
     age for a brother or sister, and a photo. The server checks the change and
     rewrites the story; the new story is saved on the book once it exists. */
  var MAX_EDITS = 3;

  function chatSay(who, text) {
    var log = $('#sb-chat-log');
    var line = el('p', 'sb-chat__msg sb-chat__msg--' + who, text);
    if (log) log.appendChild(line);
    chatScroll();
    return line;
  }

  /* An answer grows after it is shown; keep the newest words in view. */
  function chatScroll() {
    var log = $('#sb-chat-log');
    if (log) log.scrollTop = log.scrollHeight;
  }

  /* One thing at a time: a change is written, then saved, then the next. The
     chat stays shut while either runs, and a save never starts while a change
     is being written, so a change can never land on a story that was undone. */
  function chatBusy(on) {
    state.chatBusy = on;
    var shut = on || !!state.saving || (state.editsUsed || 0) >= MAX_EDITS;
    var send = $('#sb-chat-send'), input = $('#sb-chat-input');
    if (send) send.disabled = shut;
    if (input) input.disabled = shut;
  }

  function chatLeft() {
    var left = Math.max(0, MAX_EDITS - (state.editsUsed || 0));
    var n = $('#sb-chat-left');
    if (n) n.textContent = left ? left + (left === 1 ? ' change' : ' changes') + ' left' : 'All ' + MAX_EDITS + ' changes used';
    chatBusy(!!state.chatBusy);
  }

  /* One chat, moved to the step on screen. Only for a signed-in parent. */
  function placeChat() {
    var chat = $('#sb-chat');
    if (!chat) return;
    var show = !!state.session && !!state.story && (state.step === 6 || state.step === 7);
    chat.hidden = !show;
    if (!show) return;
    var slot = $(state.step === 7 ? '#sb-chat-slot-7' : '#sb-chat-slot-6');
    if (slot && chat.parentNode !== slot) slot.appendChild(chat);
    chatLeft();
  }

  function chatError(err) {
    var status = err && err.status;
    if (status === 401) return 'Your sign-in expired. Enter your number again and try once more.';
    return (err && err.body && typeof err.body.error === 'string' && err.body.error) ||
      'Something went wrong on our side. Please try again.';
  }

  function findPerson(name) {
    var n = String(name || '').trim().toLowerCase();
    for (var i = 0; i < state.cast.length; i++) if (state.cast[i].name.trim().toLowerCase() === n) return state.cast[i];
    return null;
  }

  function listPages(nums) {
    if (nums.length === 1) return 'page ' + nums[0];
    // A new person plays on most pages, so a change can touch all fourteen.
    if (nums.length > 4) return nums.length + ' pages';
    return 'pages ' + nums.slice(0, -1).join(', ') + ' and ' + nums[nums.length - 1];
  }

  function sendChange(text) {
    text = String(text || '').trim();
    if (!text || state.chatBusy || state.saving || (state.editsUsed || 0) >= MAX_EDITS || !state.story) return;
    if (state.outOfSync) {
      chatSay('bot', 'This page and your book no longer match after a change we could not save. Call us on +91 7279999888 and we will put it right.');
      return;
    }
    var input = $('#sb-chat-input');
    if (input) input.value = '';
    chatBusy(true);
    chatSay('me', text);
    // The bubble the answer goes in. After questions about a new person it is
    // a fresh one at the bottom, so the chat reads in order.
    var ui = { reply: chatSay('bot', 'Reading your change…') };
    // Put the cast back if the change does not land: a person added or renamed
    // for a story that was never written is not in the book.
    var before = state.cast.map(function (p) { return Object.assign({}, p); });
    apiFetch('/api/story/change-check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        request: text,
        heroName: heroName(),
        cast: state.cast.map(function (p, i) { return { name: p.name.trim(), role: i === 0 ? 'hero' : p.role }; })
      })
    })
      .then(function (check) {
        if (!check.ok) throw { chat: check.reason || 'We cannot make that change to a children’s book.' };
        var rename = check.rename && findPerson(check.rename.from) ? check.rename : null;
        var asking = (check.newPeople || []).some(function (p) { return p && p.name && !findPerson(p.name); });
        if (asking) ui.reply.textContent = 'One thing first.';
        return askPeople(check.newPeople || []).then(function (added) {
          if (rename) findPerson(rename.from).name = rename.to;
          if (asking) ui.reply = chatSay('bot', '');
          return reviseStory(text, added, rename, ui.reply);
        });
      })
      .catch(function (err) {
        state.cast = before;
        saveDraft();
        var box = $('#sb-chat-person');
        if (box) { box.hidden = true; box.innerHTML = ''; }
        ui.reply.textContent = err && err.chat ? err.chat : chatError(err);
        chatScroll();
        if (!(err && err.chat)) console.error('[storybook] story change failed', err && err.status, err && err.body);
        chatBusy(false);
        flushSave(); // a save held back while this change was being written
      });
  }

  /* Each new person in turn: who they are, an age for a brother or sister,
     a photo. */
  function askPeople(list) {
    var added = [];
    return list.reduce(function (chain, guess) {
      return chain.then(function () {
        if (!guess || !guess.name || findPerson(guess.name)) return;
        if (state.cast.length >= MAX_PEOPLE) {
          throw { chat: 'A book holds ' + MAX_PEOPLE + ' people, so we cannot add ' + guess.name + '.' };
        }
        return askPerson(guess).then(function (person) { state.cast.push(person); added.push(person); });
      });
    }, Promise.resolve()).then(function () { return added; });
  }

  function askPerson(guess) {
    return new Promise(function (resolve, reject) {
      var box = $('#sb-chat-person');
      var name = String(guess.name).trim();
      var person = { id: nextId++, name: name, role: guess.role || '', gender: guess.gender || IMPLIED[guess.role] || '',
                     age: null, photo: null, photoPath: null, referenceId: null, viaChat: true };
      chatSay('bot', 'Who is ' + name + ' to ' + (heroName() || 'your child') + '? Then add a photo of ' + name + '.');
      box.hidden = false;

      function chips(options, isOn, pick, cls) {
        var row = el('div', 'sb-chat__chips' + (cls ? ' ' + cls : ''));
        options.forEach(function (o) {
          var b = el('button', 'sb-castadd__chip' + (isOn(o[0]) ? ' sb-castadd__chip--on' : ''), o[1]);
          b.type = 'button';
          b.setAttribute('aria-pressed', isOn(o[0]) ? 'true' : 'false');
          b.addEventListener('click', function () { pick(o[0]); paint(); });
          row.appendChild(b);
        });
        return row;
      }

      function paint() {
        box.innerHTML = '';
        box.appendChild(chips(ROLES.filter(function (r) { return r.key !== 'hero'; }).map(function (r) { return [r.key, r.name]; }),
          function (k) { return person.role === k; },
          function (k) {
            var was = person.role;
            person.role = k;
            person.gender = IMPLIED[k] || (IMPLIED[was] ? '' : person.gender);
            person.age = null;
          }));
        if (person.role && !IMPLIED[person.role]) {
          box.appendChild(el('span', 'sb-character-slot__label', 'In the story, ' + name + ' is'));
          box.appendChild(chips([['he', 'He'], ['she', 'She']], function (g) { return person.gender === g; }, function (g) { person.gender = g; }));
        }
        if (person.role === 'brother' || person.role === 'sister') {
          box.appendChild(el('span', 'sb-character-slot__label', 'How old is ' + name + '? (optional)'));
          var ages = [[1, 'Baby']];
          for (var a = 2; a <= 12; a++) ages.push([a, String(a)]);
          ages.push([13, '13+']);
          box.appendChild(chips(ages, function (n) { return person.age === n; }, function (n) { person.age = person.age === n ? null : n; }, 'sb-chat__chips--ages'));
        }
        var ready = !!person.role && !!person.gender;
        var pickPhoto = el('label', 'sb-btn sb-btn--secondary sb-chat__photo' + (ready ? '' : ' sb-chat__photo--off'), 'Add a photo of ' + name);
        var input = el('input');
        input.type = 'file';
        input.accept = 'image/jpeg,image/png,image/webp';
        input.disabled = !ready;
        input.hidden = true;
        input.addEventListener('change', function () {
          if (!input.files[0]) return;
          var note = chatSay('bot', 'Checking the photo…');
          uploadPersonPhoto(person, input.files[0])
            .then(function () { note.textContent = 'Got it.'; box.hidden = true; box.innerHTML = ''; resolve(person); })
            .catch(function (err) { note.textContent = (err && err.body && err.body.error) || 'That photo did not work. Try one taken front-on, in good light.'; });
        });
        pickPhoto.appendChild(input);
        box.appendChild(pickPhoto);
        var cancel = el('button', 'sb-chat__cancel', 'Cancel this change');
        cancel.type = 'button';
        cancel.addEventListener('click', function () { reject({ chat: 'Okay, nothing changed.' }); });
        box.appendChild(cancel);
      }
      paint();
    });
  }

  /* The same photo check step 5 uses: shrunk in the browser, face-checked on
     the server, the original kept for drawing. */
  function uploadPersonPhoto(person, file) {
    if (file.size > PHOTO_MAX_ORIGINAL_BYTES) return Promise.reject({ body: { error: 'That file is over 30 MB. Try a smaller one.' } });
    return shrinkPhoto(file).then(function (photo) {
      person.photo = URL.createObjectURL(photo);
      var fd = new FormData();
      fd.append('photo', photo, photo.name || 'photo.jpg');
      fd.append('name', person.name);
      fd.append('role', person.role);
      fd.append('gender', person.gender);
      fd.append('skipReference', '1');
      return apiFetch('/api/character/preview', { method: 'POST', body: fd });
    }).then(function (res) {
      var data = res.data || res;
      person.photoPath = data.photoPath || null;
      if (!person.photoPath) throw new Error('no photo path returned');
      makeThumb(person.photo).then(function (t) { person.thumb = t; saveDraft(); });
    });
  }

  function reviseStory(text, added, rename, reply) {
    var h = hero();
    var reviseJobId = null;
    reply.textContent = 'Rewriting the story. This takes about a minute.';
    return apiJob('/api/story/revise', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        story: state.story,
        request: text,
        hero: { name: h.name.trim(), role: 'hero', gender: h.gender, age: h.age },
        others: state.cast.slice(1).map(function (p) { return { name: p.name.trim(), role: p.role, gender: p.gender, age: personAge(p) }; }),
        // As at step 3, so the title keeps a sibling the parent put in it.
        cover: coverApplies() ? state.cover : undefined,
        coHeroes: coHeroNames(),
        // Kept through a change: the writer must keep each one in the scenes.
        things: thingNames(),
        background: true
      })
    }, { onId: function (id) { reviseJobId = id; } })
      .then(function (res) {
        var changed = res.changed || [];
        var titleChanged = !!res.titleChanged;
        var story = Object.assign({}, res);
        delete story.changed;
        delete story.titleChanged;
        state.story = story;
        state.storyKey = storyKey();
        state.editsUsed = (state.editsUsed || 0) + 1;
        // The save first, and the draft with it: a page that fails to redraw
        // below must never leave a new story on screen with no save behind it.
        chatBusy(false);
        queueSave({ reviseJobId: reviseJobId, newPeople: added, renames: rename ? [rename] : [] });
        saveDraft();
        try {
          var page = state.readerIndex;
          startReader();
          showReaderPage(page);
          syncPreviewStory();
          renderSoFar();
        } catch (e) {
          console.error('[storybook] redrawing after a change failed', e);
        }
        // The child or a sibling in the title: the painted preview cover keeps the old name.
        var titleRenamed = rename && (rename.to === h.name || coHeroNames().indexOf(rename.to) >= 0);
        reply.textContent = (changed.length ? 'Done. I changed ' + listPages(changed) + '.' : 'Done.') +
          (titleChanged || titleRenamed ? ' The printed cover will use the new ' + (titleChanged ? 'title' : 'name') + '.' : '');
        chatScroll();
        chatLeft();
      });
  }

  /* The new story goes onto the book record. While the pictures are still
     being created there is no record yet, so the save waits for it. Only the
     newest story is saved; new people and renames add up in order. */
  function queueSave(change) {
    var p = state.pendingSave || { reviseJobId: null, newPeople: [], renames: [] };
    state.pendingSave = {
      reviseJobId: change.reviseJobId,
      story: state.story,
      cast: cloneCast(),
      newPeople: p.newPeople.concat(change.newPeople.map(function (q) {
        var age = personAge(q);
        return { name: q.name.trim(), role: q.role, gender: q.gender, age: age === undefined ? null : age, photoPath: q.photoPath };
      })),
      renames: p.renames.concat(change.renames)
    };
    flushSave();
  }

  function flushSave() {
    var p = state.pendingSave;
    if (!p || !state.generationId || !state.editKey || state.saving || state.chatBusy) return;
    var book = state.generationId;
    // The save stays in pendingSave (and the draft) until the server says it
    // landed: a reload mid-save sends it again, and the server answers a
    // repeat with ok.
    state.saving = true;
    chatBusy(false);
    // A save that hangs would keep the chat and the cart shut; give up after
    // 30 s and keep it for the next try.
    var stop = new AbortController();
    var timer = setTimeout(function () { stop.abort(); }, 30000);
    apiFetch('/api/book/story', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ generationId: state.generationId, editKey: state.editKey, reviseJobId: p.reviseJobId,
                             newPeople: p.newPeople, renames: p.renames }),
      signal: stop.signal
    })
      .then(function (res) {
        clearTimeout(timer);
        state.saving = false;
        if (book === state.generationId) { // not a book that was drawn again meanwhile
          var left = res && typeof res.editsLeft === 'number' ? res.editsLeft : null;
          state.saved = { story: p.story, cast: p.cast, saves: left === null ? ((state.saved && state.saved.saves) || 0) + 1 : MAX_EDITS - left };
          state.pendingSave = null;
          saveDraft();
        }
        chatLeft();
      })
      .catch(function (err) {
        clearTimeout(timer);
        state.saving = false;
        chatLeft();
        if (book !== state.generationId) return;
        var status = err && err.status;
        // A dropped connection, a time-out, our side, a lapsed sign-in or another
        // save landing at the same moment: keep it for the next try (signing in,
        // the next change, or the cart button). Anything else the server will
        // refuse every time, and kept it would stop the book going into the
        // cart for good.
        var again = !status || status >= 500 || status === 401 ||
          (status === 409 && /changed while/.test((err.body && err.body.error) || ''));
        if (again) {
          chatSay('bot', status === 401
            ? 'Your sign-in expired. Enter your number again and we will save your change.'
            : 'We could not save that change to your book yet. We will try again.');
        } else {
          // The screen must show what will print: back to the story and the
          // people the book record holds. Nothing else is running (one thing
          // at a time). The change still counts: its rewrite was paid for.
          state.pendingSave = null;
          var back = state.saved && state.saved.story && Array.isArray(state.saved.cast) ? state.saved : null;
          if (back) {
            state.story = back.story;
            state.cast = back.cast.map(function (r) {
              var p = personFromRecord(r);
              var now = findPersonById(r.id);
              if (now && now.photo) p.photo = now.photo; // keep the full photo already on screen
              return p;
            });
            state.storyKey = storyKey();
            var at = state.readerIndex;
            startReader();
            showReaderPage(at);
            syncPreviewStory();
            renderSoFar();
            chatSay('bot', chatError(err) + ' That change is not in your book, so the story is back to how your book has it.');
          } else {
            state.outOfSync = true;
            chatSay('bot', chatError(err) + ' That change is not in your book. Call us on +91 7279999888 and we will put it right.');
          }
        }
        saveDraft();
        console.error('[storybook] saving the changed story failed', status, err && err.body);
      });
  }

  /* The book on screen at step 7 shows the new words straight away. */
  function syncPreviewStory() {
    if (!state.pages || !state.pages.length || !state.story) return;
    (state.story.spreads || []).forEach(function (spread, k) {
      var page = state.pages[k + 2];
      if (page && page.kind !== 'cover' && page.kind !== 'character') page.text = spread.text;
    });
    var cover = state.pages[0];
    if (cover && cover.kind === 'cover') {
      cover.titleName = state.story.titleName || heroName();
      cover.titleRest = state.story.title;
      cover.text = storyTitle();
    }
    state.bookTitle = storyTitle();
    if (state.step === 7) renderPreview();
  }

  /* The book record exists once the pictures are done: note it, and save any
     change made while they were being created. */
  function noteBook(res) {
    var data = (res && res.data) || res || {};
    state.generationId = data.generationId || data.generation_id || state.generationId || null;
    state.editKey = data.editKey || state.editKey || null;
    flushSave();
  }

  /* Open the drawn preview. Held by the caller until the parent is signed in. */
  function showPreview(res, startAt) {
    var data = res.data || res;
    state.generationId = data.generationId || data.generation_id || null;
    state.pages = data.pages || []
    state.bookTitle = data.title || ''
    if (Array.isArray(data.refused) && data.refused.length) {
      console.warn('[storybook] the content filter refused', data.refused.length, 'picture(s)')
    };
    // The pictures were drawn from the story as it was when they started. A
    // change made since is the story the book prints, so the preview and the
    // cart's title follow it.
    if (state.editsUsed) syncPreviewStory();
    state.pageIndex = Math.min(startAt || 0, Math.max(0, state.pages.length - 1));
    renderPreview();
    goToStep(7);
  }

  /* The cover is not a spread.
     The printed book typesets the title OVER the illustration, in whichever
     half luna left empty. Drawing it as "words on the left page, picture on the
     right" showed the buyer something the book will never look like -- and the
     cover is what they judge the purchase on. */
  function renderCover(page, spread) {
    spread.classList.add('sb-book-spread--cover');
    var p = currentPalette();
    var wrap = el('div', 'sb-cover');
    wrap.style.setProperty('--cover-ink', p.ink);
    wrap.style.setProperty('--cover-panel', p.panel);

    if (page.imageUrl) {
      var img = el('img', 'sb-cover__art');
      img.src = page.imageUrl;
      img.alt = 'The cover of ' + (page.text || 'the book');
      wrap.appendChild(img);
    } else {
      wrap.appendChild(el('div', 'sb-cover__art sb-cover__art--empty'));
    }

    // A cover the illustrator lettered is finished: the title is painted into
    // the picture, in the same medium, and has been read back letter for
    // letter. Laying our type over it would print the title twice.
    if (page.lettered) {
      spread.appendChild(wrap);
      return;
    }

    // The title goes in the half the hero is NOT in. A fixed side lands on the
    // child's face whenever the model composes the other way round.
    var side = page.heroSide === 'right' ? 'left' : 'right';
    var band = el('div', 'sb-cover__band sb-cover__band--' + side);
    var type = el('div', 'sb-cover__type');
    type.style.fontFamily = p.dfam;
    type.style.letterSpacing = p.dls;

    if (page.titleName) type.appendChild(el('span', 'sb-cover__name', page.titleName.toUpperCase()));
    if (page.titleRest) {
      type.appendChild(el('span', 'sb-cover__joiner', 'AND THE'));
      type.appendChild(el('span', 'sb-cover__title', page.titleRest));
    }
    if (!page.titleName && !page.titleRest) {
      type.appendChild(el('span', 'sb-cover__title', page.text || ''));
    }
    band.appendChild(type);
    wrap.appendChild(band);
    spread.appendChild(wrap);
  }

  function renderPreview() {
    var title = $('#sb-preview-title');
    if (title) title.textContent = state.bookTitle || ('Here ' + (hero().gender === 'she' ? 'she' : 'he') + ' is.');
    var page = state.pages[state.pageIndex];
    var spread = $('#sb-book-spread');
    var left = $('#sb-page-left'), right = $('#sb-page-right');
    if (!page || !left || !right || !spread) return;
    spread.classList.remove('sb-book-spread--turn');
    void spread.offsetWidth;
    spread.classList.add('sb-book-spread--turn');

    left.innerHTML = '';
    right.innerHTML = '';
    var oldCover = spread.querySelector('.sb-cover');
    if (oldCover) oldCover.remove();
    spread.classList.remove('sb-book-spread--cover');
    left.style.display = '';
    right.style.display = '';

    if (page.kind === 'cover') {
      left.style.display = 'none';
      right.style.display = 'none';
      renderCover(page, spread);
    } else {
      left.appendChild(el('p', 'sb-page-text', page.text || ''));
      if (page.imageUrl) {
        var img = el('img');
        img.src = page.imageUrl;
        img.alt = 'Illustration';
        img.loading = 'lazy';
        right.appendChild(img);
      } else if (page.artPending) {
        right.appendChild(pendingArt());
      }
    }

    var num = $('#sb-page-num');
    if (num) {
      num.textContent = page.kind === 'cover'
        ? 'Front cover'
        : page.kind === 'character'
          ? (hero().name || 'Your child') + ', drawn for this book'
          : 'Spread ' + (state.pageIndex - 1) + ' of ' + (state.pages.length - 2);
    }
    var prev = $('#sb-page-prev'), next = $('#sb-page-next');
    if (prev) prev.disabled = state.pageIndex === 0;
    if (next) next.disabled = state.pageIndex >= state.pages.length - 1;
  }

  /* A page whose picture is painted after the order. The parent reads the
     whole story before buying (Sahil, 22 Sep 2026), so every page shows, with
     a soft wash in the chosen look's colours where the picture will go. Never
     a drawn figure: a sketched boy is wrong on a girl's book. */
  function pendingArt() {
    var p = currentPalette();
    var name = hero().name || '';
    var box = el('div', 'sb-pending');
    box.style.setProperty('--sb-bloom-1', p.swatches[0]);
    box.style.setProperty('--sb-bloom-2', p.swatches[1]);
    box.style.setProperty('--sb-bloom-3', p.swatches[2]);
    var wash = el('div', 'sb-bloom');
    wash.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 6; i++) wash.appendChild(el('span', 'sb-bloom__blob'));
    box.appendChild(wash);
    var note = el('div', 'sb-pending__note');
    note.appendChild(el('p', 'sb-pending__title', name ? name + '’s picture goes here' : 'A picture goes here'));
    note.appendChild(el('p', 'sb-pending__text', 'We illustrate every page after you order, with ' + (name || 'your child') + ' right at the heart of it.'));
    box.appendChild(note);
    return box;
  }

  /* ---------- add to cart ---------- */

  function cartError(message) {
    var box = $('#sb-cart-error'), txt = $('#sb-cart-error-text');
    if (!box || !txt) return;
    if (!message) { box.style.display = 'none'; return; }
    txt.textContent = message;
    box.style.display = '';
  }

  function chosenFormat() {
    var picked = $('input[name="sb-format"]:checked');
    return picked ? picked.value : 'softcover';
  }

  // The finished book is emailed to the address typed on step 7: a
  // phone-only checkout leaves the order itself with no email. Until it is a
  // real address the button stays grey and the field amber.
  // One address: no spaces, commas or angle brackets, no empty dot parts.
  var EMAIL_RE = /^[^\s@,;<>]+@[^\s@,;<>.]+(\.[^\s@,;<>.]+)+$/;
  function bookEmail() { return (($('#sb-book-email-input') || {}).value || '').trim(); }
  function syncBookEmail() {
    var ok = EMAIL_RE.test(bookEmail());
    var input = $('#sb-book-email-input'), btn = $('#sb-add-to-cart-btn');
    if (input) {
      input.classList.toggle('is-missing', !ok);
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    }
    if (btn) btn.disabled = !ok;
    return ok;
  }

  function addToCart() {
    var btn = $('#sb-add-to-cart-btn');
    cartError('');

    // A change the parent asked for must be on the book before it is ordered,
    // or the printed book tells the old story.
    if (state.chatBusy || state.saving) return cartError('One moment: we are saving your change to the story.');
    if (state.outOfSync) return cartError('This page and your book no longer match after a change we could not save. Call us on +91 7279999888 and we will put it right.');
    if (state.pendingSave) {
      flushSave();
      return cartError('Saving your change to the story. Tap again in a moment.');
    }

    var format = chosenFormat();
    var variantId = VARIANTS[format];
    if (!variantId) {
      // A missing setting is a shop problem, not a parent problem. Say what we
      // can do about it rather than failing silently on a Shopify 404.
      cartError('We cannot open the basket just now. Please call us on +91 7279999888 and we will take the order.');
      console.error('[storybook] no variant id configured for', format);
      return;
    }

    // The generation id is the whole point. Without it the order is an order
    // for a book nobody can find, so refuse rather than take the money.
    if (!state.generationId) {
      cartError('Something went wrong saving this book. Draw the preview again and we will try once more.');
      return;
    }

    if (!syncBookEmail()) return;

    var h = hero();
    var dedication = ($('#sb-dedication-text') || {}).value || '';

    // Properties prefixed with an underscore stay out of the customer's sight
    // and off the confirmation email. The rest are there so the buyer and our
    // support desk can read the order without opening a database.
    var properties = {
      _generation_id: state.generationId,
      _look: state.look || '',
      _theme: state.theme ? state.theme.key : (state.ownIdea || 'own-idea'),
      'Child': h.name || '',
      'Story': state.bookTitle || ''
    };
    if (dedication.trim()) properties['Dedication'] = dedication.trim();
    properties._book_email = bookEmail();

    busy(btn, true, 'Adding');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: properties }] })
    })
      .then(function (r) {
        return r.text().then(function (body) {
          var data;
          try { data = JSON.parse(body); } catch (e) { data = { description: body }; }
          if (!r.ok) throw new Error(data.description || data.message || 'Could not add to the basket');
          return data;
        });
      })
      .then(function () {
        clearDraft(); // the book is in the basket; nothing left to resume
        window.location.href = '/cart';
      })
      .catch(function (err) {
        busy(btn, false, 'Make Their Book');
        syncBookEmail();
        console.error('[storybook] add to cart failed', err);
        cartError('We could not add it to your basket. Please try again.');
      });
  }

  /* ---------- sample dialog ---------- */

  function bindSample() {
    var dialog = document.getElementById('sb-sample');
    if (!dialog) return;
    var flip = bindCarousel(
      document.getElementById('sb-flip'),
      document.getElementById('sb-flip-prev'),
      document.getElementById('sb-flip-next'),
      document.getElementById('sb-flip-dots')
    );
    function open() {
      dialog.hidden = false;
      document.body.style.overflow = 'hidden';
      flip.go(0, true);
      flip.paint();
    }
    function close() { dialog.hidden = true; document.body.style.overflow = ''; }
    // The landing hero has one too, outside the wizard, so look page-wide.
    Array.prototype.forEach.call(document.querySelectorAll('[data-sb-sample-open]'), function (b) {
      b.addEventListener('click', open);
    });
    Array.prototype.forEach.call(dialog.querySelectorAll('[data-sb-sample-close]'), function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !dialog.hidden) close();
    });
  }

  /* ---------- keeping the book across a reload ---------- */

  /* Safari throws away a tab it is not showing when the phone needs memory,
     and reloads it when the parent comes back. Before this the wizard started
     over, and a book already drawn on the server was drawn -- and paid for --
     again. The choices and the ids of any running jobs are kept on the phone
     for 12 hours, with a small thumbnail of each photo; the pictures of the
     book are fetched from the server again. Cleared once the book is in the
     basket. */
  var DRAFT_KEY = 'sb-draft-v1';
  var DRAFT_TTL_MS = 12 * 60 * 60 * 1000;

  function saveDraft() {
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify({
        savedAt: Date.now(),
        step: state.step,
        cast: state.cast.map(personRecord),
        things: state.things.map(thingRecord),
        band: state.band ? state.band.key : null,
        theme: state.theme,
        ownIdea: state.ownIdea,
        cover: state.cover,
        coverChosen: !!state.coverChosen,
        coHeroIds: state.coHeroIds,
        look: state.look,
        story: state.story,
        storyKey: state.storyKey,
        storyJobId: state.storyJobId,
        previewJobId: state.previewJobId,
        editsUsed: state.editsUsed || 0,
        saved: state.saved || null,
        outOfSync: !!state.outOfSync,
        pendingSave: state.pendingSave || null,
        bookEmail: bookEmail()
      }));
    } catch (e) { /* private mode or storage full: it just cannot survive a reload */ }
  }

  function loadDraft() {
    try {
      var d = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null');
      if (d && Date.now() - d.savedAt < DRAFT_TTL_MS && Array.isArray(d.cast) && d.cast.length) return d;
    } catch (e) { /* unreadable: start fresh */ }
    clearDraft();
    return null;
  }

  function clearDraft() {
    try { localStorage.removeItem(DRAFT_KEY); } catch (e) { /* nothing to clear */ }
  }

  /* A 160px JPEG of the uploaded photo, small enough to keep in the draft. */
  function makeThumb(src) {
    return new Promise(function (resolve) {
      if (!src) return resolve(null);
      var img = new Image();
      img.onload = function () {
        try {
          var scale = Math.min(1, 160 / Math.max(img.naturalWidth, img.naturalHeight));
          var c = document.createElement('canvas');
          c.width = Math.round(img.naturalWidth * scale);
          c.height = Math.round(img.naturalHeight * scale);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          resolve(c.toDataURL('image/jpeg', 0.7));
        } catch (e) { resolve(null); }
      };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
  }

  function resumeDraft(d) {
    state.cast = d.cast.map(personFromRecord);
    state.cast.forEach(function (p) { if (p.id >= nextId) nextId = p.id + 1; });
    state.things = Array.isArray(d.things) ? d.things.slice(0, MAX_THINGS).map(thingFromRecord) : [];
    state.things.forEach(function (t) { if (t.id >= nextId) nextId = t.id + 1; });
    state.band = d.band ? (BANDS.filter(function (b) { return b.key === d.band; })[0] || null) : null;
    state.theme = d.theme || null;
    state.ownIdea = d.ownIdea || '';
    state.cover = d.cover === 'hero' ? 'hero' : 'everyone';
    state.coverChosen = !!d.coverChosen;
    state.coHeroIds = Array.isArray(d.coHeroIds) ? d.coHeroIds : [];
    state.look = d.look || null;
    state.story = d.story || null;
    state.storyKey = d.storyKey || null;
    state.editsUsed = d.editsUsed || 0;
    state.saved = d.saved || null;
    state.outOfSync = !!d.outOfSync;
    state.pendingSave = d.pendingSave || null;
    var emailInput = $('#sb-book-email-input');
    if (emailInput && !emailInput.value && d.bookEmail) emailInput.value = d.bookEmail;
    syncBookEmail();

    if (state.story) {
      state.storyPromise = Promise.resolve(state.story);
    } else if (d.storyJobId) {
      // The story was still being written. Ask for the same one.
      var key = state.storyKey;
      var job = state.storyJob = {};
      state.storyJobId = d.storyJobId;
      state.storyPromise = pollJob(d.storyJobId, job)
        .then(function (res) { if (state.storyKey === key) { state.story = res; saveDraft(); } return res; })
        .catch(function () { if (state.storyKey === key) { state.story = null; state.storyJobId = null; } return null; });
    }

    hideLanding();
    root.dataset.awaitingStart = 'false';
    renderCast();
    if (d.previewJobId) {
      state.previewJobId = d.previewJobId; // kept, in case the tab is reloaded again
      return drawBook(d.previewJobId);
    }
    goToStep(Math.min(d.step, LAST_INPUT_STEP));
  }

  /* ---------- init ---------- */

  /* The wizard waits for the landing button. If this page has no landing
     section, there is nothing to wait for and it shows straight away.

     Starting does NOT scroll down to the wizard. It takes the hero off the
     page and puts step 1 at the top, so the button reads as "next page"
     rather than "jump to the bottom of this one". */
  function bindStart() {
    var starters = Array.prototype.slice.call(document.querySelectorAll('[data-sb-start]'));
    if (!starters.length) return;
    root.dataset.awaitingStart = 'true';
    starters.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        hideLanding();
        root.dataset.awaitingStart = 'false';
        goToStep(1);
        // goToStep scrolls the wizard into view. With the hero gone the wizard
        // IS the top of the page, so go there outright and skip the slide.
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
    });
  }

  /* Shopify wraps each section in its own element, so hide the wrapper and the
     hero leaves no gap behind. Falls back to the inner block if the theme ever
     stops wrapping. */
  function hideLanding() {
    var hero = document.querySelector('.sb-landing');
    if (!hero) return;
    var wrapper = hero.closest('.shopify-section') || hero;
    wrapper.style.display = 'none';
  }

  function init() {
    var draft = loadDraft();
    renderCast();
    bindStart();

    state.looksCarousel = bindCarousel($('#sb-looks'), $('#sb-looks-prev'), $('#sb-looks-next'), $('#sb-looks-dots'));

    // A saved book comes back for 12 hours; this is the way out of it.
    var reset = $('#sb-sofar-reset');
    if (reset) reset.addEventListener('click', function () { clearDraft(); window.location.reload(); });
    var thingAdd = $('#sb-things-add');
    if (thingAdd) thingAdd.addEventListener('click', function () {
      if (state.things.length >= MAX_THINGS) return;
      var t = { id: nextId++, kind: 'thing', name: '', photo: null, thumb: null, photoPath: null };
      state.things.push(t);
      renderThings();
      var input = document.getElementById('sb-thing-' + t.id);
      if (input) input.focus();
    });

    $$('[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () {
        var target = +b.dataset.goto;
        if (target > state.step && !canLeave(state.step)) return;
        // Leaving step 3 means the child and the theme are settled — enough to
        // write the story. Start it now rather than at generate time.
        if (state.step === 3 && target > 3) { startStory(); fetchTeasers(); }
        goToStep(target);
      });
    });

    var gen = $('#sb-generate-btn');
    if (gen) gen.addEventListener('click', startGenerate);

    var cart = $('#sb-add-to-cart-btn');
    if (cart) cart.addEventListener('click', addToCart);

    bindSignin();

    var retry = $('#sb-generation-retry');
    if (retry) retry.addEventListener('click', function () {
      var box = $('#sb-generation-error');
      if (box) box.style.display = 'none';
      startGenerate();
    });

    // The book turns with the arrows, a swipe, or the keyboard.
    function turn(by) {
      var to = state.pageIndex + by;
      if (state.step !== 7 || to < 0 || to > state.pages.length - 1) return;
      state.pageIndex = to;
      renderPreview();
    }
    var prev = $('#sb-page-prev'), next = $('#sb-page-next');
    if (prev) prev.addEventListener('click', function () { turn(-1); });
    if (next) next.addEventListener('click', function () { turn(1); });
    var book = $('#sb-book-spread');
    if (book) {
      var startX = null;
      book.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
      book.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) turn(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    document.addEventListener('keydown', function (e) {
      if (/^(INPUT|TEXTAREA|SELECT)$/.test((e.target && e.target.tagName) || '')) return;
      if (e.key === 'ArrowRight') turn(1);
      if (e.key === 'ArrowLeft') turn(-1);
    });

    var readerPrev = $('#sb-reader-prev'), readerNext = $('#sb-reader-next');
    if (readerPrev) readerPrev.addEventListener('click', function () { showReaderPage(state.readerIndex - 1); });
    if (readerNext) readerNext.addEventListener('click', function () { showReaderPage(state.readerIndex + 1); });
    var readerPage = $('#sb-reader-page'), swipeX = null;
    if (readerPage) {
      readerPage.addEventListener('touchstart', function (e) { swipeX = e.touches[0].clientX; }, { passive: true });
      readerPage.addEventListener('touchend', function (e) {
        if (swipeX === null) return;
        var dx = e.changedTouches[0].clientX - swipeX;
        swipeX = null;
        if (Math.abs(dx) > 40) showReaderPage(state.readerIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    var chatForm = $('#sb-chat-form'), chatInput = $('#sb-chat-input');
    if (chatForm) chatForm.addEventListener('submit', function (e) { e.preventDefault(); sendChange(chatInput && chatInput.value); });
    if (chatInput) chatInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendChange(chatInput.value); }
    });

    var makeOpen = $('#sb-make-open');
    if (makeOpen) makeOpen.addEventListener('click', function () {
      var res = state.readyPreview;
      if (!res) return;
      state.readyPreview = null;
      // At the page they were reading: the preview is the cover, the
      // character, then the spreads.
      showPreview(res, state.readerIndex > 0 ? state.readerIndex + 2 : 0);
    });

    var ded = $('#sb-dedication-text'), dedCount = $('#sb-dedication-count');
    if (ded && dedCount) ded.addEventListener('input', function () { dedCount.textContent = ded.value.length + ' / 300'; });
    var bookEmailInput = $('#sb-book-email-input');
    if (bookEmailInput) {
      // 'change' too: some autofill and form restore set the value without 'input'.
      bookEmailInput.addEventListener('input', syncBookEmail);
      bookEmailInput.addEventListener('change', function () { syncBookEmail(); saveDraft(); });
    }
    syncBookEmail();


    bindSample();
    if (draft && (draft.step > 1 || draft.previewJobId)) resumeDraft(draft);
    else goToStep(1);

    // Ask early, not at step 5. A parent who signed in at the checkout popup
    // should never see the gate flash up before it resolves.
    checkSession();

    // Back from the basket shows this page exactly as it was left, with the
    // button still spinning from the add. Give the button back.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { busy($('#sb-add-to-cart-btn'), false, 'Make Their Book'); syncBookEmail(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
